// community-mixed
//
// Purpose: Community mixed and novelty preset categories
//
// This module:
// - Exports preset categories: Other Community Novelty, Community Drums

import { toNameMap } from "../../../synth/synth-config";
import type { InputPresetCategory } from "./types";

export const mixedCommunityCategories: InputPresetCategory[] = [
	{
		name: "Other Community Novelty Presets",
		presets: toNameMap([
			{
				name: "hardware kick - Mathieu",
				generalMidi: false,
				tags: ["fm", "fm4op", "kick", "novelty"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["panning", "transition type", "note filter", "bitcrusher", "reverb"],
					transition: "normal",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 1000,
							linearGain: 2,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 1000,
							linearGain: 2,
						},
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 }],
					bitcrusherOctave: 6,
					bitcrusherQuantization: 0,
					pan: 0,
					panDelay: 0,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "50×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "none",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "neglected sawtooth - CoolTasDude",
				generalMidi: false,
				tags: ["chip", "customchip", "cooltasdude", "novelty"],
				settings: {
					type: "custom chip",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 1 }],
					effects: ["panning", "transition type", "vibrato", "chorus", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					vibrato: "custom",
					vibratoDepth: 0.12,
					vibratoDelay: 8,
					vibratoSpeed: 4,
					vibratoType: 0,
					pan: 0,
					panDelay: 10,
					chorus: 14,
					reverb: 19,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					unison: "custom",
					unisonVoices: 2,
					unisonSpread: 4.894,
					unisonOffset: 3,
					unisonExpression: 0.8,
					unisonSign: 0.5,
					unisonBuzzes: false,
					wave: "1/4 pulse",
					customChipWave: {
						"0": -24,
						"1": -24,
						"2": -23,
						"3": -22,
						"4": -21,
						"5": -20,
						"6": -19,
						"7": -16,
						"8": -12,
						"9": -6,
						"10": -2,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": -23,
						"26": -20,
						"27": -14,
						"28": -9,
						"29": -5,
						"30": -5,
						"31": -2,
						"32": 16,
						"33": 16,
						"34": 16,
						"35": 16,
						"36": 4,
						"37": 4,
						"38": 4,
						"39": 4,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 6,
						"52": 4,
						"53": 1,
						"54": -2,
						"55": -4,
						"56": -7,
						"57": -11,
						"58": -13,
						"59": -13,
						"60": -13,
						"61": -14,
						"62": -14,
						"63": -13,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "burnt speaker - CoolTasDude",
				generalMidi: false,
				tags: ["fm", "fm4op", "cooltasdude", "novelty"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.3536 }],
					effects: ["panning", "note filter"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.3536 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.3536 }],
					pan: 0,
					panDelay: 0,
					fadeInSeconds: 0.0938,
					fadeOutTicks: 12,
					algorithm: "(1 2)←3←4",
					feedbackType: "1→2",
					feedbackAmplitude: 3,
					operators: [
						{
							frequency: "0.25×",
							amplitude: 14,
							waveform: "pulse width",
							pulseWidth: 5,
						},
						{ frequency: "11×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 14, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 1, waveform: "pulse width", pulseWidth: 1 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 5.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1.6667,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorFrequency",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.3,
							perEnvelopeUpperBound: 0.6,
							discrete: false,
							index: 2,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 4.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "decimated kick - CoolTasDude",
				generalMidi: false,
				tags: ["fm", "fm4op", "cooltasdude", "novelty", "kick"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 500,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 500,
							linearGain: 0.5,
						},
					],
					effects: [
						"panning",
						"pitch shift",
						"vibrato",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					pitchShiftSemitones: 12,
					vibrato: "custom",
					vibratoDepth: 0.92,
					vibratoDelay: 18,
					vibratoSpeed: 30,
					vibratoType: 0,
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 6,
					bitcrusherQuantization: 57,
					pan: 0,
					panDelay: 10,
					chorus: 0,
					echoSustain: 43,
					echoDelayBeats: 0.5,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pitchShift",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pitchShift",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Metallic Bass - CoolTasDude",
				generalMidi: false,
				tags: ["noise", "cooltasdude", "novelty"],
				settings: {
					type: "noise",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["panning", "note filter", "distortion", "chorus"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.3536 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.3536 }],
					distortion: 57,
					aliases: false,
					pan: 0,
					panDelay: 0,
					chorus: 100,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "1-bit metallic",
					unison: "detune",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "hollow shaft - Perriot",
				generalMidi: false,
				tags: ["spectrum", "novelty"],
				settings: {
					type: "spectrum",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 }],
					eqFilterType: true,
					eqSimpleCut: 8,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["panning", "transition type", "note filter", "chorus", "reverb"],
					transition: "continue",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 }],
					pan: 0,
					panDelay: 10,
					chorus: 100,
					reverb: 29,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -3,
					unison: "custom",
					unisonVoices: 2,
					unisonSpread: 4,
					unisonOffset: 4,
					unisonExpression: 1,
					unisonSign: 1,
					unisonBuzzes: false,
					spectrum: [
						57, 0, 14, 57, 57, 0, 29, 29, 71, 0, 14, 0, 14, 43, 71, 0, 29, 0, 29, 57, 0,
						29, 29, 29, 0, 0, 0, 14, 14, 0,
					],
					envelopes: [
						{ target: "chorus", envelope: "swell 1" },
						{ target: "chorus", envelope: "swell 1" },
						{
							target: "noteVolume",
							envelope: "swell -1",
						},
					],
					isDrum: false,
				},
			},
			{
				name: "expired glass - Perriot",
				generalMidi: false,
				tags: ["fm", "fm4op", "novelty"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 0.0884 },
						{
							type: "low-pass",
							cutoffHz: 5656.85,
							linearGain: 0.0884,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 0.0884 },
						{
							type: "low-pass",
							cutoffHz: 5656.85,
							linearGain: 0.0884,
						},
					],
					effects: ["echo"],
					panDelay: 0,
					echoSustain: 29,
					echoDelayBeats: 1.5,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteVolume", envelope: "twang 1" },
						{
							target: "operatorAmplitude",
							envelope: "twang 2",
							index: 0,
						},
					],
				},
			},
			{
				name: "jello kick - HappyLemonLime",
				generalMidi: false,
				tags: ["fm", "fm6op", "happylemonlime", "novelty", "kick"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.1768 },
						{
							type: "peak",
							cutoffHz: 1189.21,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.1768 },
						{
							type: "peak",
							cutoffHz: 1189.21,
							linearGain: 0.5,
						},
					],
					effects: ["panning", "note filter", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 2.8284 }],
					pan: 0,
					panDelay: 0,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "1←(2 3 4 5 6)",
					feedbackType: "1→4 2→5 3→6",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "0.12×", amplitude: 15, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "5×", amplitude: 8, waveform: "pulse width", pulseWidth: 6 },
						{
							frequency: "0.75×",
							amplitude: 9,
							waveform: "pulse width",
							pulseWidth: 6,
						},
						{ frequency: "7×", amplitude: 3, waveform: "ramp", pulseWidth: 5 },
						{
							frequency: "0.75×",
							amplitude: 11,
							waveform: "quasi-sine",
							pulseWidth: 5,
						},
						{ frequency: "~1×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "wibble 1" },
						{ target: "operatorAmplitude", envelope: "wibble 3", index: 1 },
						{ target: "operatorAmplitude", envelope: "linear-1", index: 3 },
						{ target: "operatorAmplitude", envelope: "swell -1", index: 4 },
						{ target: "operatorAmplitude", envelope: "swell 1", index: 5 },
						{ target: "feedbackAmplitude", envelope: "twang 2" },
					],
					isDrum: false,
				},
			},
			{
				name: "Discord Ping - HappyLemonLime",
				generalMidi: false,
				tags: ["fm", "fm6op", "happylemonlime", "novelty"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.1768 },
						{
							type: "peak",
							cutoffHz: 1189.21,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.1768 },
						{
							type: "peak",
							cutoffHz: 1189.21,
							linearGain: 0.5,
						},
					],
					effects: ["panning", "note filter", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 2.8284 }],
					pan: 0,
					panDelay: 0,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "1←(2 3 4 5 6)",
					feedbackType: "1→4 2→5 3→6",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "0.12×", amplitude: 15, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "5×", amplitude: 8, waveform: "pulse width", pulseWidth: 6 },
						{
							frequency: "0.75×",
							amplitude: 9,
							waveform: "pulse width",
							pulseWidth: 6,
						},
						{ frequency: "7×", amplitude: 3, waveform: "ramp", pulseWidth: 5 },
						{
							frequency: "0.75×",
							amplitude: 11,
							waveform: "quasi-sine",
							pulseWidth: 5,
						},
						{ frequency: "~1×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "wibble 1" },
						{ target: "operatorAmplitude", envelope: "wibble 3", index: 1 },
						{ target: "operatorAmplitude", envelope: "linear-1", index: 3 },
						{ target: "operatorAmplitude", envelope: "swell -1", index: 4 },
						{ target: "operatorAmplitude", envelope: "swell 1", index: 5 },
						{ target: "feedbackAmplitude", envelope: "twang 2" },
					],
					isDrum: false,
				},
			},
			{
				name: "a preset of unknown origin",
				generalMidi: false,
				tags: ["pwm", "novelty"],
				settings: {
					type: "PWM",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"panning",
						"transition type",
						"note filter",
						"granular",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "peak", cutoffHz: 5656.85, linearGain: 11.3137 }],
					noteSubFilters0: [{ type: "peak", cutoffHz: 5656.85, linearGain: 11.3137 }],
					granular: 9,
					grainSize: 43,
					grainAmounts: 1,
					grainRange: 9,
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 4,
					bitcrusherQuantization: 29,
					pan: 0,
					panDelay: 0,
					chorus: 14,
					echoSustain: 86,
					echoDelayBeats: 0.417,
					reverb: 23,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 27,
					decimalOffset: 0,
					unison: "hum",
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 4.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
							steps: 32,
							seed: 19,
							waveform: 3,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Dirty Whistle - ThatBeepboxGuy",
				generalMidi: false,
				tags: ["spectrum", "thatbeepboxguy", "novelty"],
				settings: {
					type: "spectrum",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["panning", "note filter", "chorus", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 2.8284 },
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 176.78, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 250, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 11.3137 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 2.8284 },
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 176.78, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 250, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 11.3137 },
					],
					pan: 0,
					panDelay: 10,
					chorus: 100,
					reverb: 71,
					fadeInSeconds: 0.1575,
					fadeOutTicks: 96,
					spectrum: [
						100, 29, 29, 29, 29, 29, 14, 14, 14, 14, 0, 0, 0, 0, 14, 0, 0, 0, 0, 0, 0,
						0, 0, 0, 0, 0, 0, 0, 0, 0,
					],
					unison: "none",
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "Superstar - Bagel",
				generalMidi: false,
				tags: ["supersaw", "bagel", "novelty"],
				settings: {
					type: "supersaw",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 5,
					eqSubFilters0: [],
					effects: [
						"panning",
						"chord type",
						"pitch shift",
						"detune",
						"note filter",
						"distortion",
						"bitcrusher",
					],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					pitchShiftSemitones: 12,
					detuneCents: 44,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 1189.21, linearGain: 0.5 }],
					distortion: 86,
					aliases: false,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 71,
					pan: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 50,
					decimalOffset: 0,
					dynamism: 100,
					spread: 50,
					shape: 0,
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "Air Raid Siren - Bagel",
				generalMidi: false,
				tags: ["fm", "fm6op", "bagel", "novelty"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [
						{ type: "high-pass", cutoffHz: 176.78, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 2.8284,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 176.78, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 2.8284,
						},
					],
					effects: ["panning", "reverb"],
					pan: 0,
					panDelay: 0,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "1←3←4 2←5←6",
					feedbackType: "3→4",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "0.25×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 15, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 0, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "9×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 14, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "operatorAmplitude", envelope: "tremolo1", index: 2 }],
					isDrum: false,
				},
			},
			{
				name: "cat piano - truemori",
				generalMidi: false,
				tags: ["chip", "chipwave", "truemori", "novelty"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["panning", "note filter", "distortion", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1.4142 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1.4142 }],
					distortion: 43,
					aliases: false,
					pan: 0,
					panDelay: 0,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					wave: "modbox atari pulse",
					unison: "warbled",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 15,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "flare 2" }],
					isDrum: false,
				},
			},
			{
				name: "bubble echo pad - Calamity",
				generalMidi: false,
				tags: ["harmonics", "calamity", "novelty"],
				settings: {
					type: "harmonics",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 2 },
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.3536 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 2 },
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.3536 },
					],
					effects: ["panning", "pitch shift", "vibrato", "echo", "reverb"],
					pitchShiftSemitones: 0,
					vibrato: "custom",
					vibratoDepth: 0.2,
					vibratoDelay: 43,
					vibratoSpeed: 10,
					vibratoType: 0,
					pan: 0,
					panDelay: 10,
					echoSustain: 86,
					echoDelayBeats: 1,
					reverb: 39,
					fadeInSeconds: 0.075,
					fadeOutTicks: -1,
					harmonics: [
						100, 57, 71, 29, 14, 0, 29, 14, 0, 29, 43, 43, 0, 29, 14, 29, 14, 14, 29,
						57, 0, 57, 29, 43, 14, 0, 14, 29,
					],
					unison: "custom",
					unisonVoices: 1,
					unisonSpread: 0,
					unisonOffset: 0.25,
					unisonExpression: 1,
					unisonSign: 1,
					envelopes: [
						{ target: "pitchShift", envelope: "punch" },
						{
							target: "pitchShift",
							envelope: "punch",
						},
					],
					isDrum: false,
				},
			},
			{
				name: "wah noise - Calamity",
				generalMidi: false,
				tags: ["fm", "fm6op", "calamity", "novelty"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [{ type: "high-pass", cutoffHz: 250, linearGain: 0.0884 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 250, linearGain: 0.0884 }],
					effects: ["panning", "chord type", "note filter", "distortion", "chorus"],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					distortion: 86,
					aliases: false,
					pan: 0,
					panDelay: 10,
					chorus: 71,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←3←4 2←5←6",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 11,
					operators: [
						{ frequency: "50×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 12, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorFrequency", envelope: "tremolo3", index: 0 },
						{ target: "operatorAmplitude", envelope: "rise 1", index: 2 },
						{ target: "operatorAmplitude", envelope: "note size", index: 3 },
						{ target: "operatorAmplitude", envelope: "note size", index: 0 },
					],
					isDrum: false,
				},
			},
			// -------------JukeBox 0.1.6 newcomers--------------
			{
				name: "Muffled Bubbles - HoneykitKD",
				generalMidi: false,
				tags: ["fm", "fm4op", "honeykitkd", "novelty"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 1.4142 },
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 4 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 1.4142 },
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 4 },
					],
					effects: ["transition type", "vibrato", "note filter", "chorus", "reverb"],
					transition: "continue",
					clicklessTransition: false,
					vibrato: "heavy",
					vibratoDepth: 0.45,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 }],
					panDelay: 10,
					chorus: 100,
					reverb: 3,
					fadeInSeconds: 0.0413,
					fadeOutTicks: -3,
					algorithm: "1←(2 3) 2←4",
					feedbackType: "3⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "0.25×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 14, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 5.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
					],
				},
			},
			{
				name: "Fuzzy Radio - HoneykitKD",
				generalMidi: false,
				tags: ["spectrum", "honeykitkd", "novelty"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 4 },
						{
							type: "peak",
							cutoffHz: 594.6,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.1768 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 4 },
						{
							type: "peak",
							cutoffHz: 594.6,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.1768 },
					],
					effects: ["note filter", "granular", "bitcrusher"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 1681.79, linearGain: 0.5 }],
					granular: 4,
					grainSize: 25,
					grainAmounts: 9,
					grainRange: 9,
					bitcrusherOctave: 4,
					bitcrusherQuantization: 71,
					panDelay: 10,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 6,
					spectrum: [
						100, 14, 0, 43, 14, 0, 29, 86, 0, 0, 14, 100, 0, 0, 100, 29, 100, 29, 86,
						14, 0, 86, 43, 0, 0, 43, 0, 0, 0, 0,
					],
					unison: "none",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 1.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.3,
							discrete: false,
						},
						{
							target: "bitcrusherFrequency",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 14,
							perEnvelopeLowerBound: 1.1,
							perEnvelopeUpperBound: 1.4,
							discrete: false,
							steps: 4,
							seed: 52,
							waveform: 2,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "grainSize",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 2.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Wet Pluck - HoneykitKD",
				generalMidi: false,
				tags: ["pickedstring", "honeykitkd", "featured", "novelty"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.1768 },
						{
							type: "peak",
							cutoffHz: 1681.79,
							linearGain: 2,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.1768 },
						{
							type: "peak",
							cutoffHz: 1681.79,
							linearGain: 2,
						},
					],
					effects: ["transition type", "pitch shift", "chorus", "reverb"],
					transition: "slide",
					clicklessTransition: false,
					pitchShiftSemitones: 8,
					panDelay: 10,
					chorus: 100,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						0, 43, 43, 0, 100, 0, 0, 0, 0, 0, 57, 0, 0, 29, 71, 0, 29, 14, 0, 0, 0, 0,
						0, 0, 71, 0, 0, 0,
					],
					unison: "vibrate",
					stringSustain: 0,
					envelopes: [
						{
							target: "pitchShift",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 13,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "chorus",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 2.5,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1.1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
						{
							target: "noteVolume",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 3,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Distorted Whispers - HoneykitKD",
				generalMidi: false,
				tags: ["chip", "chipwave", "honeykitkd", "novelty"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 2000,
							linearGain: 0.25,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 2000,
							linearGain: 0.25,
						},
					],
					effects: ["vibrato", "note filter", "granular", "distortion", "reverb"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 1681.79, linearGain: 5.6569 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 8,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 1681.79, linearGain: 5.6569 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 8,
						},
					],
					granular: 4,
					grainSize: 47,
					grainAmounts: 8,
					grainRange: 40,
					distortion: 29,
					aliases: false,
					panDelay: 10,
					reverb: 3,
					fadeInSeconds: 0.075,
					fadeOutTicks: 96,
					wave: "trumpet",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "goofy goober woobler - HoneykitKD",
				generalMidi: false,
				tags: ["spectrum", "honeykitkd", "novelty"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 1681.79,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 1681.79,
							linearGain: 0.5,
						},
					],
					effects: ["transition type", "pitch shift", "vibrato", "reverb"],
					transition: "slide",
					clicklessTransition: false,
					pitchShiftSemitones: 11,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 10,
					reverb: 29,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					spectrum: [
						86, 14, 14, 0, 0, 29, 0, 100, 0, 0, 0, 100, 14, 43, 57, 0, 100, 0, 86, 0, 0,
						100, 14, 14, 29, 14, 0, 0, 29, 0,
					],
					unison: "shimmer",
					envelopes: [
						{
							target: "pitchShift",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 6.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			// -------------JukeBox 0.2.0 newcomers--------------
			{
				name: "Distorted Theremin - SomethingOriginal",
				generalMidi: false,
				tags: ["harmonics", "somethingoriginal", "novelty"],
				settings: {
					type: "harmonics",
					eqFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.7071 }],
					effects: ["transition type", "vibrato", "distortion", "chorus", "reverb"],
					transition: "slide",
					clicklessTransition: false,
					vibrato: "heavy",
					vibratoDepth: 0.45,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					distortion: 71,
					aliases: false,
					panDelay: 10,
					chorus: 100,
					reverb: 32,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -6,
					harmonics: [
						100, 71, 57, 43, 29, 29, 14, 14, 14, 14, 14, 14, 14, 0, 0, 0, 0, 0, 0, 0, 0,
						0, 0, 0, 0, 0, 0, 0,
					],
					unison: "bowed",
					envelopes: [],
				},
			},
			{
				name: "Too Much Wub - Jacobar475",
				generalMidi: false,
				tags: ["fm", "fm6op", "jacobar475", "novelty"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "peak", cutoffHz: 420.45, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 5656.85,
							linearGain: 11.3137,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 420.45, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 5656.85,
							linearGain: 11.3137,
						},
					],
					eqSubFilters1: [],
					effects: [],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲ 5⟲ 6⟲",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[], [3], [6], [6, 5], [6], []], carrierCount: 2 },
					operators: [
						{ frequency: "~1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 15, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "3.5×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~4×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "250×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.12×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Corrupted Artifacts - ThatBeepboxGuy",
				generalMidi: false,
				tags: ["harmonics", "thatbeepboxguy", "novelty"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 840.9,
							linearGain: 0.1768,
						},
						{ type: "peak", cutoffHz: 2000, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 840.9,
							linearGain: 0.1768,
						},
						{ type: "peak", cutoffHz: 2000, linearGain: 2 },
					],
					eqSubFilters1: [
						{ type: "low-pass", cutoffHz: 297.3, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 840.9,
							linearGain: 0.1768,
						},
						{ type: "peak", cutoffHz: 2000, linearGain: 2 },
					],
					eqSubFilters2: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 840.9,
							linearGain: 0.1768,
						},
						{ type: "peak", cutoffHz: 2000, linearGain: 2 },
					],
					effects: [
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					distortion: 100,
					aliases: false,
					bitcrusherOctave: 2.5,
					bitcrusherQuantization: 43,
					panDelay: 0,
					chorus: 100,
					echoSustain: 43,
					echoDelayBeats: 0.75,
					reverb: 68,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 100, 71, 57, 57, 43, 43, 43, 29, 29, 14, 29, 29, 29, 14, 29, 14, 14,
						29, 14, 14, 29, 29, 29, 29, 29, 29, 29,
					],
					unison: "corrupt",
					envelopes: [],
				},
			},
			{
				name: "Max Overdriven Guitar - 3001ideaz",
				generalMidi: false,
				tags: ["pickedstring", "3001ideaz", "novelty"],
				settings: {
					type: "Picked String",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["note filter", "distortion"],
					noteFilterType: true,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					distortion: 100,
					aliases: false,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,
						100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,
					],
					unison: "none",
					stringSustain: 71,
					envelopes: [],
				},
			},
			{
				name: "Max Overdriven Piano - 3001ideaz",
				generalMidi: false,
				tags: ["pickedstring", "3001ideaz", "novelty"],
				settings: {
					type: "Picked String",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["transition type", "note filter", "distortion", "reverb"],
					transition: "continue",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					distortion: 100,
					aliases: false,
					panDelay: 0,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,
						100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,
					],
					unison: "piano",
					stringSustain: 79,
					envelopes: [],
				},
			},
			{
				name: "Blizzard - SunflowerSupreme",
				generalMidi: false,
				tags: ["noise", "novelty"],
				settings: {
					type: "noise",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 250, linearGain: 1.4142 },
						{
							type: "peak",
							cutoffHz: 210.22,
							linearGain: 11.3137,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 250, linearGain: 1.4142 },
						{
							type: "peak",
							cutoffHz: 210.22,
							linearGain: 11.3137,
						},
					],
					effects: ["chord type", "pitch shift", "note filter", "reverb"],
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 2,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 2.8284 }],
					panDelay: 0,
					reverb: 19,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "white",
					unison: "hecking gosh",
					envelopes: [
						{ target: "pitchShift", envelope: "twang 1" },
						{
							target: "noteFilterAllFreqs",
							envelope: "wibble 3",
						},
					],
				},
			},
			{
				name: "Ewwew - SunflowerSupreme",
				generalMidi: false,
				tags: ["pwm", "novelty"],
				settings: {
					type: "PWM",
					eqFilter: [{ type: "low-pass", cutoffHz: 3049.17, linearGain: 1.4142 }],
					eqFilterType: true,
					eqSimpleCut: 7,
					eqSimplePeak: 3,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["note filter", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 11.3137 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 11.3137 }],
					panDelay: 0,
					reverb: 0,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 6,
					pulseWidth: 8,
					decimalOffset: 0,
					unison: "bowed",
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "wibble 2" }],
				},
			},
			{
				name: "Cowboy Whistle - Xelerate_XD",
				generalMidi: false,
				tags: ["fm", "fm4op", "novelty"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 7586.61, linearGain: 11.3137 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 7,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["pitch shift", "vibrato", "note filter", "chorus", "reverb"],
					pitchShiftSemitones: 10,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 4,
					noteSimplePeak: 5,
					noteFilter: [{ type: "low-pass", cutoffHz: 1007.3, linearGain: 2 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 1007.3, linearGain: 2 }],
					panDelay: 0,
					chorus: 100,
					reverb: 32,
					fadeInSeconds: 0.0575,
					fadeOutTicks: -3,
					algorithm: "1←(2 3 4)",
					feedbackType: "ALL",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "pitchShift",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 10,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Square Seizure - Xelerate_XD",
				generalMidi: false,
				tags: ["fm", "fm4op", "novelty"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["detune", "note filter", "distortion", "bitcrusher", "chorus"],
					detuneCents: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 1000,
							linearGain: 1.4142,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 1000,
							linearGain: 1.4142,
						},
					],
					distortion: 100,
					aliases: false,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 100,
					panDelay: 0,
					chorus: 29,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -3,
					algorithm: "1←(2 3 4)",
					feedbackType: "(1 2 3)→4",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "100×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "50×", amplitude: 2, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "250×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 5, waveform: "pulse width", pulseWidth: 0 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
							waveform: 0,
							steps: 2,
						},
						{
							target: "noteFilterFreq",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "distortion",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Very Offtuned Grand Piano - Xelerate_XD",
				generalMidi: false,
				tags: ["pickedstring", "novelty"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 4 },
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 4 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.25 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 4 },
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 4 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.25 },
					],
					effects: [
						"pitch shift",
						"detune",
						"vibrato",
						"note filter",
						"chorus",
						"reverb",
					],
					pitchShiftSemitones: 8,
					detuneCents: -40,
					vibrato: "heavy",
					vibratoDepth: 0.45,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 0.0884,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 0.0884,
						},
					],
					panDelay: 0,
					chorus: 100,
					reverb: 68,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					harmonics: [
						100, 100, 86, 86, 86, 71, 71, 71, 0, 71, 71, 71, 71, 57, 57, 71, 57, 14, 57,
						57, 57, 57, 57, 57, 57, 57, 29, 57,
					],
					unison: "honky tonk",
					stringSustain: 86,
					envelopes: [
						{ target: "noteFilterFreq", envelope: "note size", index: 0 },
						{ target: "noteFilterFreq", envelope: "twang 1", index: 1 },
						{ target: "noteFilterFreq", envelope: "twang 1", index: 1 },
						{ target: "detune", envelope: "punch" },
						{ target: "pitchShift", envelope: "twang 3" },
					],
				},
			},
			// -------------JukeBox 0.2.1 presets--------------
			{
				name: "Resonant Whistle - 3001ideaz",
				generalMidi: false,
				tags: ["harmonics", "3001ideaz", "novelty"],
				settings: {
					type: "harmonics",
					eqFilter: [{ type: "low-pass", cutoffHz: 2110.37, linearGain: 1.4142 }],
					eqFilterType: true,
					eqSimpleCut: 6,
					eqSimplePeak: 3,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["transition type", "vibrato", "distortion", "chorus", "reverb"],
					transition: "slide",
					clicklessTransition: false,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					distortion: 29,
					aliases: false,
					panDelay: 0,
					chorus: 100,
					reverb: 0,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -3,
					harmonics: [
						100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
						0, 0, 0,
					],
					unison: "resonance",
					envelopes: [],
				},
			},
			{
				name: "that one wind gust - Jacobar475",
				generalMidi: false,
				tags: ["spectrum", "jacobar475", "novelty"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 500, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 4756.83,
							linearGain: 2.8284,
						},
						{ type: "peak", cutoffHz: 5656.85, linearGain: 2.8284 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 500, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 4756.83,
							linearGain: 2.8284,
						},
						{ type: "peak", cutoffHz: 5656.85, linearGain: 2.8284 },
					],
					effects: ["transition type", "note filter"],
					transition: "slide",
					clicklessTransition: false,
					noteFilterType: true,
					noteSimpleCut: 8,
					noteSimplePeak: 1,
					noteFilter: [{ type: "low-pass", cutoffHz: 6000, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 6000, linearGain: 0.5 }],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					spectrum: [
						100, 0, 0, 0, 14, 14, 0, 57, 29, 0, 0, 100, 0, 14, 43, 0, 57, 0, 71, 29, 43,
						86, 0, 0, 14, 29, 0, 0, 14, 0,
					],
					unison: "hum",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Oe Bass - CoolTasDude",
				generalMidi: false,
				tags: ["chip", "customchip", "cooltasdude", "novelty"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 6000, linearGain: 0.5 }],
					eqFilterType: true,
					eqSimpleCut: 8,
					eqSimplePeak: 1,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["pitch shift", "chorus", "reverb"],
					pitchShiftSemitones: 24,
					panDelay: 10,
					chorus: 43,
					reverb: 6,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -3,
					wave: "square",
					unison: "custom",
					unisonVoices: 3,
					unisonSpread: 0.1,
					unisonOffset: 0.1,
					unisonExpression: 0.33,
					unisonSign: 0.8,
					customChipWave: {
						"0": 2,
						"1": -6,
						"2": -11,
						"3": -14,
						"4": -16,
						"5": -18,
						"6": -20,
						"7": -21,
						"8": -22,
						"9": -22,
						"10": -23,
						"11": -23,
						"12": -23,
						"13": -23,
						"14": -22,
						"15": -22,
						"16": -22,
						"17": -21,
						"18": -20,
						"19": -19,
						"20": -17,
						"21": -15,
						"22": -13,
						"23": -9,
						"24": -3,
						"25": -1,
						"26": 1,
						"27": 3,
						"28": 5,
						"29": 7,
						"30": 8,
						"31": 9,
						"32": 9,
						"33": 10,
						"34": 10,
						"35": 10,
						"36": 11,
						"37": 11,
						"38": 11,
						"39": 11,
						"40": 11,
						"41": 11,
						"42": 11,
						"43": 11,
						"44": 11,
						"45": 11,
						"46": 11,
						"47": 10,
						"48": 10,
						"49": 10,
						"50": 9,
						"51": 9,
						"52": 8,
						"53": 6,
						"54": 5,
						"55": 5,
						"56": 4,
						"57": 2,
						"58": -6,
						"59": -14,
						"60": -20,
						"61": -24,
						"62": -24,
						"63": -24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "pitchShift",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "pitchShift",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 2,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Hacking Square - Dono915",
				generalMidi: false,
				tags: ["chip", "customchip", "novelty"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "high-pass", cutoffHz: 62.5, linearGain: 2.8284 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 62.5, linearGain: 2.8284 }],
					effects: ["transition type", "note filter"],
					transition: "normal",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "high-pass", cutoffHz: 176.78, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "high-pass", cutoffHz: 176.78, linearGain: 2.8284 }],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": 9,
						"1": 8,
						"2": -22,
						"3": -23,
						"4": 3,
						"5": 1,
						"6": -1,
						"7": -2,
						"8": -2,
						"9": 1,
						"10": 3,
						"11": -12,
						"12": -12,
						"13": -10,
						"14": 9,
						"15": 10,
						"16": 10,
						"17": 9,
						"18": 9,
						"19": 8,
						"20": 7,
						"21": 6,
						"22": 4,
						"23": -8,
						"24": -7,
						"25": 2,
						"26": 1,
						"27": 2,
						"28": 2,
						"29": 3,
						"30": 3,
						"31": 4,
						"32": -11,
						"33": -11,
						"34": -12,
						"35": -13,
						"36": 6,
						"37": 6,
						"38": 6,
						"39": 7,
						"40": 7,
						"41": 7,
						"42": 6,
						"43": 6,
						"44": 5,
						"45": 5,
						"46": 4,
						"47": 4,
						"48": -16,
						"49": 4,
						"50": 4,
						"51": 4,
						"52": 4,
						"53": 4,
						"54": 4,
						"55": 4,
						"56": 5,
						"57": 5,
						"58": 5,
						"59": 6,
						"60": 6,
						"61": 6,
						"62": 7,
						"63": 10,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{ target: "noteFilterFreq", envelope: "twang 1", index: 0 },
						{
							target: "noteVolume",
							envelope: "punch",
						},
					],
				},
			},
			// -------------JukeBox 0.2.1 presets--------------
			{
				name: "Glitchy FM - 3001ideaz",
				generalMidi: false,
				tags: ["fm", "fm6op", "3001ideaz", "novelty"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.25 },
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 1 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.3536 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.25 },
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 1 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.3536 },
					],
					effects: ["vibrato", "note filter"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 2.8284 }],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -12,
					algorithm: "(1 2 3 4 5)←6",
					feedbackType: "1→3",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "20×", amplitude: 3, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.12×", amplitude: 8, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{
							frequency: "3.5×",
							amplitude: 15,
							waveform: "pulse width",
							pulseWidth: 5,
						},
						{ frequency: "1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 0.9,
							perEnvelopeLowerBound: 1.1,
							perEnvelopeUpperBound: 1.3,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 14,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							steps: 6,
							seed: 45,
							waveform: 0,
						},
						{
							target: "operatorFrequency",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 0.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
						},
						{
							target: "feedbackAmplitude",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 1.25,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			// -------------JukeBox 0.2.3 presets--------------
			{
				name: "Wobbling alien - 3001ideaz",
				generalMidi: false,
				tags: ["fm", "fm4op", "3001ideaz", "novelty"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					effects: [],
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "5×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "swell 1", index: 1 },
						{
							target: "operatorAmplitude",
							envelope: "punch",
							index: 3,
						},
						{ target: "feedbackAmplitude", envelope: "swell 1" },
					],
				},
			},
			{
				name: "Bird 5 - Sandbox2",
				generalMidi: false,
				tags: ["pickedstring", "novelty"],
				settings: {
					type: "Picked String",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chord type", "detune", "note filter", "bitcrusher"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					detuneCents: 67,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.1768 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.1768 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4000, linearGain: 2.8284 }],
					bitcrusherOctave: 2.5,
					bitcrusherQuantization: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					harmonics: [
						100, 100, 86, 86, 86, 86, 71, 71, 57, 43, 43, 29, 29, 14, 14, 0, 0, 0, 0, 0,
						0, 0, 0, 0, 0, 0, 0, 0,
					],
					unison: "fifth",
					stringSustain: 64,
					envelopes: [],
				},
			},
			{
				name: "Gramo Organ - Treethletress",
				generalMidi: false,
				tags: ["fm", "fm4op", "treethletress", "novelty"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.3536 }],
					effects: [
						"transition type",
						"chord type",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"reverb",
						"ring modulation",
						"phaser",
						"invert wave",
						"granular",
					],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					strumParts: 6,
					vibrato: "custom",
					vibratoDepth: 0.32,
					vibratoDelay: 19,
					vibratoSpeed: 5,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.25 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.25 }],
					granular: 10,
					grainSize: 8,
					grainAmounts: 3,
					grainRange: 24,
					distortion: 43,
					aliases: false,
					bitcrusherOctave: 6,
					bitcrusherQuantization: 43,
					ringMod: 14,
					ringModHz: 51,
					rmWaveformIndex: 0,
					rmPulseWidth: 0,
					rmHzOffset: 50,
					phaserMix: 52,
					phaserFreq: 0,
					phaserFeedback: 0,
					phaserStages: 6,
					invertWave: true,
					panDelay: 10,
					chorus: 86,
					reverb: 23,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "(1 2 3)←4",
					feedbackType: "1⟲ 2⟲ 3⟲",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterFreq", envelope: "twang 2", index: 0 },
						{
							target: "chorus",
							envelope: "swell 3",
						},
					],
				},
			},
			{
				name: "Hornet Pad - Treethletress",
				generalMidi: false,
				tags: ["fm", "fm4op", "treethletress", "novelty"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["transition type"],
					transition: "interrupt",
					clicklessTransition: false,
					panDelay: 10,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "rise 2", index: 1 },
						{
							target: "operatorFrequency",
							envelope: "wibble-1",
							index: 2,
						},
					],
				},
			},
			{
				name: "Compressed Guitar - Treethletress",
				generalMidi: false,
				tags: ["chip", "chipwave", "treethletress", "novelty"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 594.6,
							linearGain: 2,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 594.6,
							linearGain: 2,
						},
					],
					effects: ["vibrato", "note filter", "bitcrusher", "chorus"],
					vibrato: "heavy",
					vibratoDepth: 0.45,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 5.6569 },
						{
							type: "high-pass",
							cutoffHz: 1189.21,
							linearGain: 11.3137,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 5.6569 },
						{
							type: "high-pass",
							cutoffHz: 1189.21,
							linearGain: 11.3137,
						},
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 }],
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					unison: "octave",
					wave: "electric guitar",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Crackle Organ - Treethletress",
				generalMidi: false,
				tags: ["spectrum", "treethletress", "novelty"],
				settings: {
					type: "spectrum",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["transition type", "detune", "vibrato", "bitcrusher"],
					transition: "normal",
					clicklessTransition: false,
					detuneCents: 52,
					vibrato: "heavy",
					vibratoDepth: 0.45,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					unison: "none",
					spectrum: [
						100, 0, 0, 100, 0, 100, 0, 71, 0, 0, 0, 57, 0, 0, 57, 0, 43, 0, 43, 0, 0,
						29, 0, 29, 0, 14, 14, 14, 0, 0,
					],
					envelopes: [{ target: "noteVolume", envelope: "punch" }],
				},
			},
			{
				name: "Tremor Guitar - Treethletress",
				generalMidi: false,
				tags: ["fm", "fm4op", "treethletress", "novelty"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "peak", cutoffHz: 5656.85, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 2,
						},
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 1 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 5656.85, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 2,
						},
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 1 },
					],
					effects: [
						"pitch shift",
						"detune",
						"vibrato",
						"note filter",
						"distortion",
						"chorus",
						"echo",
						"reverb",
					],
					pitchShiftSemitones: 13,
					detuneCents: 72,
					vibrato: "custom",
					vibratoDepth: 0.48,
					vibratoDelay: 0,
					vibratoSpeed: 30,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 11.3137 },
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 1 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 11.3137 },
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 1 },
					],
					distortion: 71,
					aliases: false,
					panDelay: 10,
					chorus: 71,
					echoSustain: 0,
					echoDelayBeats: 0.083,
					reverb: 42,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 12,
					algorithm: "(1 2)←3←4",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 8,
					operators: [
						{ frequency: "~1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "5×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "11×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang 3" },
						{ target: "operatorAmplitude", envelope: "twang 3", index: 2 },
						{ target: "operatorAmplitude", envelope: "tremolo5", index: 3 },
						{ target: "feedbackAmplitude", envelope: "twang 3" },
						{ target: "detune", envelope: "rise 3" },
						{ target: "detune", envelope: "pentolo1" },
						{ target: "pitchShift", envelope: "pentolo1" },
					],
				},
			},
			{
				name: "BlackKnife Choir - DJO",
				generalMidi: false,
				tags: ["spectrum", "novelty"],
				settings: {
					type: "spectrum",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					noteFilterType: true,
					noteSimpleCut: 8,
					noteSimplePeak: 2,
					noteFilter: [{ type: "low-pass", cutoffHz: 4787.19, linearGain: 1 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4787.19, linearGain: 1 }],
					distortion: 71,
					aliases: false,
					bitcrusherOctave: 6,
					bitcrusherQuantization: 29,
					panDelay: 0,
					chorus: 100,
					echoSustain: 86,
					echoDelayBeats: 1.5,
					reverb: 100,
					fadeInSeconds: 0.0263,
					fadeOutTicks: 96,
					spectrum: [
						43, 14, 14, 14, 14, 14, 14, 100, 14, 14, 14, 57, 14, 14, 100, 14, 43, 14,
						43, 14, 14, 43, 14, 29, 14, 29, 14, 14, 29, 0,
					],
					unison: "none",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Distorted Smoke - NOVA_0943",
				generalMidi: false,
				tags: ["spectrum", "novelty"],
				settings: {
					type: "spectrum",
					eqFilter: [{ type: "low-pass", cutoffHz: 3828.43, linearGain: 0.5 }],
					eqFilterType: true,
					eqSimpleCut: 7,
					eqSimplePeak: 1,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["chord type", "note filter", "distortion", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 1681.79, linearGain: 8 },
						{
							type: "high-pass",
							cutoffHz: 500,
							linearGain: 4,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 1681.79, linearGain: 8 },
						{
							type: "high-pass",
							cutoffHz: 500,
							linearGain: 4,
						},
					],
					distortion: 100,
					aliases: false,
					panDelay: 10,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -12,
					spectrum: [
						57, 14, 0, 14, 14, 0, 0, 100, 0, 0, 0, 86, 0, 0, 86, 29, 86, 0, 57, 14, 0,
						100, 0, 14, 14, 0, 0, 0, 57, 43,
					],
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "Aow - NOVA_0943",
				generalMidi: false,
				tags: ["fm", "fm6op", "novelty"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 250, linearGain: 2 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 0.5 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 250, linearGain: 2 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 0.5 },
					],
					effects: ["transition type", "note filter"],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 1000, linearGain: 8 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 1000, linearGain: 8 }],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4 5 6)",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲ 5⟲",
					feedbackAmplitude: 3,
					operators: [
						{ frequency: "0.25×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 7, waveform: "trapezoid", pulseWidth: 5 },
						{
							frequency: "3.5×",
							amplitude: 14,
							waveform: "pulse width",
							pulseWidth: 5,
						},
						{
							frequency: "0.75×",
							amplitude: 6,
							waveform: "pulse width",
							pulseWidth: 7,
						},
						{ frequency: "0.75×", amplitude: 2, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "ramp", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 4,
						},
						{
							target: "feedbackAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "bird chirp - SuP3r",
				generalMidi: false,
				tags: ["fm", "fm4op", "sup3r", "novelty"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["note filter"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "high-pass", cutoffHz: 62.5, linearGain: 4 }],
					noteSubFilters0: [{ type: "high-pass", cutoffHz: 62.5, linearGain: 4 }],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "10×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "baby i stole candy from - SuP3r",
				generalMidi: false,
				tags: ["harmonics", "sup3r", "novelty"],
				settings: {
					type: "harmonics",
					eqFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 }],
					effects: ["vibrato", "chorus", "reverb"],
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					panDelay: 0,
					chorus: 0,
					reverb: 19,
					fadeInSeconds: 0.0938,
					fadeOutTicks: -24,
					harmonics: [
						14, 14, 14, 29, 29, 100, 86, 100, 0, 14, 14, 14, 14, 29, 0, 0, 14, 14, 14,
						0, 0, 0, 0, 0, 0, 0, 0, 0,
					],
					unison: "fifth",
					envelopes: [
						{
							target: "unison",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Submarine Alarm - Formskooooo",
				generalMidi: false,
				tags: ["fm", "fm4op", "formskooooo", "novelty"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.3536 },
						{
							type: "low-pass",
							cutoffHz: 420.45,
							linearGain: 2.8284,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.3536 },
						{
							type: "low-pass",
							cutoffHz: 420.45,
							linearGain: 2.8284,
						},
					],
					effects: ["bitcrusher"],
					bitcrusherOctave: 0,
					bitcrusherQuantization: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "8×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "noise from another room - why_need_a_username",
				generalMidi: false,
				tags: ["spectrum", "novelty"],
				settings: {
					type: "spectrum",
					eqFilter: [{ type: "low-pass", cutoffHz: 74.33, linearGain: 11.3137 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 74.33, linearGain: 11.3137 }],
					eqSubFilters1: [],
					effects: ["transition type"],
					transition: "slide in pattern",
					clicklessTransition: false,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					spectrum: [
						100, 100, 100, 100, 100, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 14,
						29, 43, 57, 57, 71, 71, 100, 100, 100,
					],
					unison: "none",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 6,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Horizon Pulse - Ashiiware",
				generalMidi: false,
				tags: ["pwm", "novelty"],
				settings: {
					type: "PWM",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.5 }],
					effects: ["pitch shift", "note filter", "distortion", "bitcrusher", "echo"],
					pitchShiftSemitones: 24,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 500,
							linearGain: 0.1768,
						},
						{ type: "peak", cutoffHz: 176.78, linearGain: 4 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 500,
							linearGain: 0.1768,
						},
						{ type: "peak", cutoffHz: 176.78, linearGain: 4 },
					],
					distortion: 86,
					aliases: false,
					bitcrusherOctave: 3,
					bitcrusherQuantization: 71,
					panDelay: 0,
					echoSustain: 57,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 50,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{
							target: "distortion",
							envelope: "fall",
							inverse: true,
							perEnvelopeSpeed: 0.25,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 1,
							steps: 2,
						},
						{
							target: "pulseWidth",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							steps: 32,
							seed: 2,
							waveform: 0,
						},
					],
				},
			},
			{
				name: "Liquibass - Ashiiware",
				generalMidi: false,
				tags: ["chip", "customchip", "novelty"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["note filter", "bitcrusher", "chorus", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "peak", cutoffHz: 16000, linearGain: 11.3137 }],
					noteSubFilters0: [{ type: "peak", cutoffHz: 16000, linearGain: 11.3137 }],
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 14,
					panDelay: 0,
					chorus: 100,
					reverb: 55,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "octave",
					customChipWave: {
						"0": -24,
						"1": -24,
						"2": -24,
						"3": -24,
						"4": -24,
						"5": -24,
						"6": -24,
						"7": -24,
						"8": -24,
						"9": -24,
						"10": -24,
						"11": -24,
						"12": -24,
						"13": -24,
						"14": -24,
						"15": -24,
						"16": 24,
						"17": 24,
						"18": 24,
						"19": 24,
						"20": 24,
						"21": 24,
						"22": 24,
						"23": 24,
						"24": 24,
						"25": 24,
						"26": 24,
						"27": 24,
						"28": 24,
						"29": 24,
						"30": 24,
						"31": 24,
						"32": 24,
						"33": 24,
						"34": 24,
						"35": 24,
						"36": 24,
						"37": 24,
						"38": 24,
						"39": 24,
						"40": 24,
						"41": 24,
						"42": 24,
						"43": 24,
						"44": 24,
						"45": 24,
						"46": 24,
						"47": 24,
						"48": 24,
						"49": 24,
						"50": 24,
						"51": 24,
						"52": 24,
						"53": 24,
						"54": 24,
						"55": 24,
						"56": 24,
						"57": 24,
						"58": 24,
						"59": 24,
						"60": 24,
						"61": 24,
						"62": 24,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterFreq",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.9,
							discrete: false,
							index: 0,
							steps: 32,
							seed: 2,
							waveform: 3,
						},
					],
				},
			},
			{
				name: "white noise - NonMouseyCan0n",
				generalMidi: false,
				tags: ["spectrum", "novelty"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 840.9,
							linearGain: 2.8284,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 840.9,
							linearGain: 2.8284,
						},
					],
					eqSubFilters1: [],
					effects: ["transition type"],
					transition: "continue",
					clicklessTransition: false,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					spectrum: [
						43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43,
						43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43,
					],
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "Paralysis Lead - NonMouseyCan0n",
				generalMidi: false,
				tags: ["harmonics", "novelty"],
				settings: {
					type: "harmonics",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["note filter", "bitcrusher", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 }],
					bitcrusherOctave: 3,
					bitcrusherQuantization: 57,
					panDelay: 10,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: -24,
					harmonics: [
						100, 43, 57, 43, 57, 43, 43, 43, 43, 43, 43, 43, 43, 29, 29, 29, 29, 29, 29,
						29, 14, 14, 14, 14, 14, 14, 14, 100,
					],
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "the bite of '87 - NonMouseyCan0n",
				generalMidi: false,
				tags: ["noise", "novelty"],
				settings: {
					type: "noise",
					eqFilter: [{ type: "peak", cutoffHz: 11313.71, linearGain: 5.6569 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "peak", cutoffHz: 11313.71, linearGain: 5.6569 }],
					eqSubFilters1: [],
					effects: ["transition type", "chord type", "pitch shift", "bitcrusher"],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					pitchShiftSemitones: 24,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 57,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "1-bit white",
					unison: "none",
					envelopes: [
						{
							target: "pitchShift",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 40,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "The Sploinky - ThatBeepBoxGuy",
				generalMidi: false,
				tags: ["fm", "fm6op", "thatbeepboxguy", "novelty"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 594.6,
							linearGain: 1.4142,
						},
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 594.6,
							linearGain: 1.4142,
						},
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 1.4142 },
					],
					effects: ["pitch shift", "note filter"],
					pitchShiftSemitones: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "1←3 2←4←5←6",
					feedbackType: "3⟲ 4⟲",
					feedbackAmplitude: 8,
					operators: [
						{ frequency: "4×", amplitude: 0, waveform: "pulse width", pulseWidth: 8 },
						{ frequency: "0.12×", amplitude: 15, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 6, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "pitchShift",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 4.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2.25,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 20,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 4.5,
							perEnvelopeLowerBound: 1.3,
							perEnvelopeUpperBound: 1.5,
							discrete: false,
							index: 5,
						},
						{
							target: "feedbackAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 9.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Dubstep Wow - DamageLoL",
				generalMidi: false,
				tags: ["fm", "fm4op", "damagelol", "novelty"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["note filter"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 2.8284 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3←4)",
					feedbackType: "3⟲",
					feedbackAmplitude: 10,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			// -------------JukeBox 0.2.4 presets--------------
			{
				name: "Glitch FM - Ashiiware",
				generalMidi: false,
				tags: ["fm", "fm4op", "novelty"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chord type", "note filter", "bitcrusher"],
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 62.5,
							linearGain: 0.7071,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 62.5,
							linearGain: 0.7071,
						},
					],
					bitcrusherOctave: 4,
					bitcrusherQuantization: 57,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "2⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "100×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "250×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteFilterFreq",
							envelope: "note size",
							inverse: true,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
					],
				},
			},
			{
				name: "Destabilized FM - Ashiiware",
				generalMidi: false,
				tags: ["fm", "fm6op", "novelty"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 707.11,
							linearGain: 2,
						},
						{ type: "peak", cutoffHz: 62.5, linearGain: 0.7071 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 707.11,
							linearGain: 2,
						},
						{ type: "peak", cutoffHz: 62.5, linearGain: 0.7071 },
					],
					effects: ["transition type", "chorus"],
					transition: "continue",
					clicklessTransition: false,
					panDelay: 10,
					chorus: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "1 2←4 3←(5 6)",
					feedbackType: "2→3",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "0.25×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 14, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "250×", amplitude: 12, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 1, waveform: "pulse width", pulseWidth: 0 },
						{
							frequency: "0.75×",
							amplitude: 10,
							waveform: "pulse width",
							pulseWidth: 7,
						},
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "wibble",
							inverse: false,
							perEnvelopeSpeed: 0.4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorFrequency",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
						},
					],
				},
			},
			{
				name: "Shiny - Ashiiware",
				generalMidi: false,
				tags: ["pickedstring", "novelty"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1.4142 },
						{
							type: "peak",
							cutoffHz: 594.6,
							linearGain: 0.5,
						},
						{ type: "peak", cutoffHz: 148.65, linearGain: 0.5 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1.4142 },
						{
							type: "peak",
							cutoffHz: 594.6,
							linearGain: 0.5,
						},
						{ type: "peak", cutoffHz: 148.65, linearGain: 0.5 },
					],
					effects: ["granular", "ring mod"],
					granular: 8,
					grainSize: 48,
					grainAmounts: 5,
					grainRange: 21,
					ringMod: 57,
					ringModHz: 98,
					ringModWaveformIndex: 0,
					ringModPulseWidth: 10,
					ringModHzOffset: 50,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					harmonics: [
						86, 0, 57, 29, 14, 14, 14, 14, 0, 43, 29, 29, 14, 29, 14, 29, 14, 0, 43, 29,
						29, 14, 71, 29, 57, 43, 14, 100,
					],
					unison: "none",
					stringSustain: 50,
					envelopes: [],
				},
			},
			{
				name: "FM Ambience - Ashiiware",
				generalMidi: false,
				tags: ["fm", "fm4op", "novelty", "ambience"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "peak", cutoffHz: 19027.31, linearGain: 4 },
						{
							type: "peak",
							cutoffHz: 13454.34,
							linearGain: 2.8284,
						},
						{ type: "high-pass", cutoffHz: 840.9, linearGain: 0.7071 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 19027.31, linearGain: 4 },
						{
							type: "peak",
							cutoffHz: 13454.34,
							linearGain: 2.8284,
						},
						{ type: "high-pass", cutoffHz: 840.9, linearGain: 0.7071 },
					],
					eqSubFilters1: [],
					effects: ["granular", "bitcrusher", "echo", "reverb"],
					granular: 4,
					grainSize: 49,
					grainAmounts: 10,
					grainRange: 40,
					bitcrusherOctave: 3,
					bitcrusherQuantization: 0,
					panDelay: 0,
					echoSustain: 43,
					echoDelayBeats: 2,
					reverb: 19,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "250×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "250×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "250×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "250×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
							steps: 32,
							seed: 2,
							waveform: 0,
						},
						{
							target: "operatorFrequency",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 1.6667,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
							steps: 32,
							seed: 1,
							waveform: 0,
						},
						{
							target: "operatorFrequency",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 0.7,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
							steps: 32,
							seed: 38,
							waveform: 0,
						},
						{
							target: "operatorFrequency",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 0.8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
							steps: 32,
							seed: 26,
							waveform: 0,
						},
						{
							target: "operatorFrequency",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
							steps: 32,
							seed: 46,
							waveform: 0,
						},
						{
							target: "operatorFrequency",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 9,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
							steps: 32,
							seed: 47,
							waveform: 0,
						},
						{
							target: "operatorFrequency",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 14,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
							steps: 32,
							seed: 46,
							waveform: 0,
						},
						{
							target: "operatorFrequency",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 13,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
							steps: 32,
							seed: 38,
							waveform: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
							waveform: 0,
							steps: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.08,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
							waveform: 0,
							steps: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.06,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
							waveform: 0,
							steps: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.09,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
							waveform: 0,
							steps: 2,
						},
						{
							target: "noteVolume",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.09,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Alarm Pulse - Ashiiware",
				generalMidi: false,
				tags: ["chip", "chipwave", "novelty"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 6727.17,
							linearGain: 11.3137,
						},
						{ type: "peak", cutoffHz: 594.6, linearGain: 4 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 6727.17,
							linearGain: 11.3137,
						},
						{ type: "peak", cutoffHz: 594.6, linearGain: 4 },
					],
					effects: [
						"chord type",
						"pitch shift",
						"granular",
						"distortion",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					pitchShiftSemitones: 0,
					granular: 5,
					grainSize: 46,
					grainAmounts: 6,
					grainRange: 20,
					distortion: 71,
					aliases: false,
					bitcrusherOctave: 6,
					bitcrusherQuantization: 29,
					panDelay: 0,
					chorus: 43,
					reverb: 26,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					wave: "modbox ramp pulse",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 4,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "pitchShift",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "granular",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "grainSize",
							envelope: "swell",
							inverse: true,
							perEnvelopeSpeed: 6,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "reverb",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 6,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "chorus",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
					],
				},
			},
			{
				name: "System Error - Formskooooo",
				generalMidi: false,
				tags: ["chip", "chipwave", "formskooooo", "novelty"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.125 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 50,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.125 }],
					effects: ["chorus", "echo", "ring mod"],
					ringMod: 86,
					ringModHz: 83,
					ringModWaveformIndex: 0,
					ringModPulseWidth: 10,
					ringModHzOffset: 50,
					panDelay: 10,
					chorus: 14,
					echoSustain: 14,
					echoDelayBeats: 0.083,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "trapezoid",
					unison: "honky tonk",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "ringModulationHz",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							steps: 9,
							seed: 26,
							waveform: 0,
						},
					],
				},
			},
			{
				name: "Glitch Screech - Formskooooo",
				generalMidi: false,
				tags: ["fm", "fm6op", "formskooooo", "novelty"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 1.4142 },
						{ type: "high-pass", cutoffHz: 250, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 500, linearGain: 0.5 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 1.4142 },
						{ type: "high-pass", cutoffHz: 250, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 500, linearGain: 0.5 },
					],
					effects: ["note filter", "granular"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.125 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.125 }],
					granular: 5,
					grainSize: 38,
					grainAmounts: 7,
					grainRange: 32,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←4(2←5 3←6",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲ 5⟲ 6⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "0.5×", amplitude: 14, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "0.12×", amplitude: 10, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.12×", amplitude: 15, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "250×", amplitude: 5, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 11, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "triangle", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 12,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.7,
							discrete: false,
						},
						{
							target: "granular",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 0.9,
							discrete: false,
							index: 4,
						},
					],
				},
			},
			{
				name: "HE IS COMING - Formskooooo",
				generalMidi: false,
				tags: ["harmonics", "formskooooo", "novelty"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 5.6569 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 1,
						},
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.125 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 5.6569 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 1,
						},
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.125 },
					],
					effects: ["transition type", "note filter"],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.1768 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.1768 }],
					panDelay: 10,
					fadeInSeconds: 0.0263,
					fadeOutTicks: 6,
					harmonics: [
						100, 14, 29, 29, 29, 0, 0, 0, 43, 14, 14, 43, 43, 57, 71, 71, 14, 43, 29,
						14, 14, 29, 0, 29, 0, 14, 0, 14,
					],
					unison: "diminished",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 10,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Dull Kick - Formskooooo",
				generalMidi: false,
				tags: ["fm", "fm4op", "formskooooo", "kick", "novelty"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "8×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 6,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Metal Twang - Jayden256",
				generalMidi: false,
				tags: ["fm", "fm6op", "novelty"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←2←3←4←5←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 4,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "ramp", pulseWidth: 5 },
						{
							frequency: "0.25×",
							amplitude: 15,
							waveform: "quasi-sine",
							pulseWidth: 5,
						},
						{ frequency: "0.5×", amplitude: 9, waveform: "sharksine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "absine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 4.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
					],
				},
			},
			{
				name: "WAAAAAOOOOWWW - Jayden256",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "novelty"],
				settings: {
					type: "custom chip",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 11.3137 },
						{
							type: "low-pass",
							cutoffHz: 11313.71,
							linearGain: 0.0884,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 11.3137 },
						{
							type: "low-pass",
							cutoffHz: 11313.71,
							linearGain: 0.0884,
						},
					],
					effects: ["transition type", "note filter"],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 1414.21, linearGain: 11.3137 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 1414.21, linearGain: 11.3137 }],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					wave: "sandbox recorder",
					unison: "none",
					customChipWave: {
						"0": -23,
						"1": -23,
						"2": -23,
						"3": -23,
						"4": -23,
						"5": -23,
						"6": -22,
						"7": -22,
						"8": -22,
						"9": -22,
						"10": -22,
						"11": -22,
						"12": -21,
						"13": -21,
						"14": -20,
						"15": -19,
						"16": -19,
						"17": -18,
						"18": -17,
						"19": -15,
						"20": -14,
						"21": 22,
						"22": 22,
						"23": 22,
						"24": 23,
						"25": 23,
						"26": 23,
						"27": 23,
						"28": 23,
						"29": 22,
						"30": 21,
						"31": 24,
						"32": -23,
						"33": -21,
						"34": -20,
						"35": -18,
						"36": -16,
						"37": -14,
						"38": -12,
						"39": -11,
						"40": -10,
						"41": -10,
						"42": -11,
						"43": -10,
						"44": -11,
						"45": -12,
						"46": -14,
						"47": -16,
						"48": 16,
						"49": 16,
						"50": 16,
						"51": 16,
						"52": 16,
						"53": 17,
						"54": 17,
						"55": 18,
						"56": 18,
						"57": 19,
						"58": 20,
						"59": 19,
						"60": 18,
						"61": 18,
						"62": 19,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteVolume",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 3,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterFreq",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
				},
			},
			// -------------JukeBox 0.3.0 presets--------------
			{
				name: "Nyowwwwwww Chorus - Formskooooo",
				generalMidi: false,
				tags: ["harmonics", "formskooooo", "novelty"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 353.55,
							linearGain: 2.8284,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 353.55,
							linearGain: 2.8284,
						},
					],
					effects: ["transition type", "vibrato", "note filter", "chorus"],
					transition: "slide",
					clicklessTransition: false,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.3536 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.3536 }],
					panDelay: 10,
					chorus: 71,
					fadeInSeconds: 0.075,
					fadeOutTicks: -1,
					harmonics: [
						86, 86, 100, 100, 71, 71, 86, 100, 86, 86, 71, 43, 43, 43, 43, 29, 29, 29,
						29, 29, 29, 14, 29, 29, 29, 43, 43, 43,
					],
					unison: "chorus",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 1.75,
							perEnvelopeLowerBound: 1,
							perEnvelopeUpperBound: 1.2,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Extremely Distorted Chip - jacobis12344",
				generalMidi: false,
				tags: ["chip", "customchip", "novelty", "retro"],
				settings: {
					type: "custom chip",
					eqFilter: [
						{ type: "peak", cutoffHz: 1189.21, linearGain: 5.6569 },
						{
							type: "low-pass",
							cutoffHz: 9513.66,
							linearGain: 0.3536,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 1189.21, linearGain: 5.6569 },
						{
							type: "low-pass",
							cutoffHz: 9513.66,
							linearGain: 0.3536,
						},
					],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"detune",
						"vibrato",
						"note filter",
						"granular",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
						"ring mod",
					],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					pitchShiftSemitones: 8,
					detuneCents: 136,
					vibrato: "none",
					vibratoDepth: 0,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 707.11,
							linearGain: 2,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 707.11,
							linearGain: 2,
						},
					],
					granular: 4,
					grainSize: 49,
					grainAmounts: 10,
					grainRange: 40,
					ringMod: 57,
					ringModHz: 51,
					ringModWaveformIndex: 5,
					ringModPulseWidth: 10,
					ringModHzOffset: 50,
					distortion: 71,
					aliases: false,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					chorus: 100,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 35,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					wave: "lemmbox trapasquare",
					unison: "extraterrestrial",
					customChipWave: {
						"0": 0,
						"1": -4,
						"2": -9,
						"3": -12,
						"4": -14,
						"5": -16,
						"6": -8,
						"7": -11,
						"8": -11,
						"9": -10,
						"10": -6,
						"11": -4,
						"12": -1,
						"13": 1,
						"14": 3,
						"15": 6,
						"16": 8,
						"17": 11,
						"18": -13,
						"19": -9,
						"20": -4,
						"21": 2,
						"22": 6,
						"23": 24,
						"24": 24,
						"25": 23,
						"26": 23,
						"27": 1,
						"28": 0,
						"29": -2,
						"30": -2,
						"31": -1,
						"32": -1,
						"33": -14,
						"34": -8,
						"35": 15,
						"36": -2,
						"37": 3,
						"38": 6,
						"39": 1,
						"40": 13,
						"41": 10,
						"42": 7,
						"43": 4,
						"44": 1,
						"45": -2,
						"46": -13,
						"47": -14,
						"48": -14,
						"49": -15,
						"50": -15,
						"51": -15,
						"52": 5,
						"53": 5,
						"54": 5,
						"55": 23,
						"56": 22,
						"57": 21,
						"58": 20,
						"59": 17,
						"60": 15,
						"61": 12,
						"62": 10,
						"63": 5,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 6,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							steps: 2,
							seed: 2,
							waveform: 0,
						},
					],
				},
			},
			{
				name: "tesseract - Jacobar475",
				generalMidi: false,
				tags: ["spectrum", "jacobar475", "novelty"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 1000, linearGain: 4 },
						{ type: "peak", cutoffHz: 176.78, linearGain: 8 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 1,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 1000, linearGain: 4 },
						{ type: "peak", cutoffHz: 176.78, linearGain: 8 },
					],
					effects: ["transition type", "note filter", "echo"],
					transition: "slide in pattern",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.125 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.125 }],
					panDelay: 10,
					echoSustain: 57,
					echoDelayBeats: 0.833,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					spectrum: [
						86, 14, 0, 0, 0, 43, 43, 100, 0, 0, 0, 100, 14, 14, 86, 0, 86, 0, 71, 29, 0,
						71, 43, 29, 0, 0, 0, 0, 43, 0,
					],
					unison: "none",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 2.75,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			// { name: "", generalMidi: false, tags:["", "novelty"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "novelty"], settings: {} },
		]),
	},
	{
		name: "Ashiiware's Drum Presets",
		presets: toNameMap([
			{
				name: "Granudrums",
				generalMidi: false,
				isNoise: true,
				tags: ["drumset", "ashiiware", "featured"],
				settings: {
					type: "drumset",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["granular", "bitcrusher", "chorus", "reverb"],
					granular: 2,
					grainSize: 27,
					grainAmounts: 10,
					grainRange: 10,
					bitcrusherOctave: 4,
					bitcrusherQuantization: 0,
					panDelay: 0,
					chorus: 0,
					reverb: 0,
					drums: [
						{
							filterEnvelope: "twang 1",
							spectrum: [
								57, 71, 71, 86, 86, 86, 71, 71, 71, 71, 57, 57, 57, 57, 43, 43, 43,
								43, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29,
							],
						},
						{
							filterEnvelope: "twang 1",
							spectrum: [
								0, 0, 0, 100, 71, 71, 57, 86, 57, 57, 57, 71, 43, 43, 57, 43, 43,
								43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43,
							],
						},
						{
							filterEnvelope: "twang 1",
							spectrum: [
								0, 0, 0, 0, 100, 57, 43, 43, 29, 57, 43, 29, 71, 43, 43, 43, 43, 57,
								43, 43, 43, 43, 43, 43, 43, 43, 29, 43, 43, 43,
							],
						},
						{
							filterEnvelope: "twang 1",
							spectrum: [
								0, 0, 0, 0, 0, 71, 57, 43, 43, 43, 57, 57, 43, 29, 57, 43, 43, 43,
								29, 43, 57, 43, 43, 43, 43, 43, 43, 29, 43, 43,
							],
						},
						{
							filterEnvelope: "decay 2",
							spectrum: [
								0, 14, 29, 43, 86, 71, 29, 43, 43, 43, 43, 29, 71, 29, 71, 29, 43,
								43, 43, 43, 57, 43, 43, 57, 43, 43, 43, 57, 57, 57,
							],
						},
						{
							filterEnvelope: "decay 1",
							spectrum: [
								0, 0, 14, 14, 14, 14, 29, 29, 29, 43, 43, 43, 57, 57, 57, 71, 71,
								71, 71, 71, 71, 71, 71, 57, 57, 57, 57, 43, 43, 43,
							],
						},
						{
							filterEnvelope: "twang 3",
							spectrum: [
								43, 43, 43, 71, 29, 29, 43, 43, 43, 29, 43, 43, 43, 29, 29, 43, 43,
								29, 29, 29, 57, 14, 57, 43, 43, 57, 43, 43, 57, 57,
							],
						},
						{
							filterEnvelope: "decay 3",
							spectrum: [
								29, 43, 43, 43, 43, 29, 29, 43, 29, 29, 43, 29, 14, 29, 43, 29, 43,
								29, 57, 29, 43, 57, 43, 71, 43, 71, 57, 57, 71, 71,
							],
						},
						{
							filterEnvelope: "twang 3",
							spectrum: [
								43, 29, 29, 43, 29, 29, 29, 57, 29, 29, 29, 57, 43, 43, 29, 29, 57,
								43, 43, 43, 71, 43, 43, 71, 57, 71, 71, 71, 71, 71,
							],
						},
						{
							filterEnvelope: "decay 3",
							spectrum: [
								57, 57, 57, 43, 57, 57, 43, 43, 57, 43, 43, 43, 71, 57, 43, 57, 86,
								71, 57, 86, 71, 57, 86, 100, 71, 86, 86, 86, 86, 86,
							],
						},
						{
							filterEnvelope: "flare 1",
							spectrum: [
								0, 0, 14, 14, 14, 14, 29, 29, 29, 43, 43, 43, 57, 57, 71, 71, 86,
								86, 100, 100, 100, 100, 100, 100, 100, 100, 86, 57, 29, 0,
							],
						},
						{
							filterEnvelope: "decay 2",
							spectrum: [
								14, 14, 14, 14, 29, 14, 14, 29, 14, 43, 14, 43, 57, 86, 57, 57, 100,
								57, 43, 43, 57, 100, 57, 43, 29, 14, 0, 0, 0, 0,
							],
						},
					],
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "Ceres Drumset",
				generalMidi: false,
				isNoise: true,
				tags: ["drumset", "ashiiware"],
				settings: {
					type: "drumset",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["chord type", "distortion", "bitcrusher"],
					chord: "monophonic",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 0,
					panDelay: 0,
					drums: [
						{
							filterEnvelope: "twang 1",
							spectrum: [
								57, 71, 71, 86, 86, 86, 71, 71, 71, 71, 57, 57, 57, 57, 43, 43, 43,
								43, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29,
							],
						},
						{
							filterEnvelope: "twang 1",
							spectrum: [
								0, 0, 0, 100, 71, 71, 57, 86, 57, 57, 57, 71, 43, 43, 57, 43, 43,
								43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43,
							],
						},
						{
							filterEnvelope: "twang 1",
							spectrum: [
								0, 0, 0, 0, 100, 57, 43, 43, 29, 57, 43, 29, 71, 43, 43, 43, 43, 57,
								43, 43, 43, 43, 43, 43, 43, 43, 29, 43, 43, 43,
							],
						},
						{
							filterEnvelope: "twang 1",
							spectrum: [
								0, 0, 0, 0, 0, 71, 57, 43, 43, 43, 57, 57, 43, 29, 57, 43, 43, 43,
								29, 43, 57, 43, 43, 43, 43, 43, 43, 29, 43, 43,
							],
						},
						{
							filterEnvelope: "decay 2",
							spectrum: [
								0, 14, 29, 43, 86, 71, 29, 43, 43, 43, 43, 29, 71, 29, 71, 29, 43,
								43, 43, 43, 57, 43, 43, 57, 43, 43, 43, 57, 57, 57,
							],
						},
						{
							filterEnvelope: "decay 1",
							spectrum: [
								0, 0, 14, 14, 14, 14, 29, 29, 29, 43, 43, 43, 57, 57, 57, 71, 71,
								71, 71, 71, 71, 71, 71, 57, 57, 57, 57, 43, 43, 43,
							],
						},
						{
							filterEnvelope: "twang 3",
							spectrum: [
								43, 43, 43, 71, 29, 29, 43, 43, 43, 29, 43, 43, 43, 29, 29, 43, 43,
								29, 29, 29, 57, 14, 57, 43, 43, 57, 43, 43, 57, 57,
							],
						},
						{
							filterEnvelope: "decay 3",
							spectrum: [
								29, 43, 43, 43, 43, 29, 29, 43, 29, 29, 43, 29, 14, 29, 43, 29, 43,
								29, 57, 29, 43, 57, 43, 71, 43, 71, 57, 57, 71, 71,
							],
						},
						{
							filterEnvelope: "twang 3",
							spectrum: [
								43, 29, 29, 43, 29, 29, 29, 57, 29, 29, 29, 57, 43, 43, 29, 29, 57,
								43, 43, 43, 71, 43, 43, 71, 57, 71, 71, 71, 71, 71,
							],
						},
						{
							filterEnvelope: "decay 3",
							spectrum: [
								57, 57, 57, 43, 57, 57, 43, 43, 57, 43, 43, 43, 71, 57, 43, 57, 86,
								71, 57, 86, 71, 57, 86, 100, 71, 86, 86, 86, 86, 86,
							],
						},
						{
							filterEnvelope: "flare 1",
							spectrum: [
								0, 0, 14, 14, 14, 14, 29, 29, 29, 43, 43, 43, 57, 57, 71, 71, 86,
								86, 100, 100, 100, 100, 100, 100, 100, 100, 86, 57, 29, 0,
							],
						},
						{
							filterEnvelope: "decay 2",
							spectrum: [
								14, 14, 14, 14, 29, 14, 14, 29, 14, 43, 14, 43, 57, 86, 57, 57, 100,
								57, 43, 43, 57, 100, 57, 43, 29, 14, 0, 0, 0, 0,
							],
						},
					],
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "Neptune Noise",
				generalMidi: false,
				isNoise: true,
				tags: ["noise", "ashiiware"],
				settings: {
					type: "noise",
					eqFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.125 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.125 }],
					effects: ["bitcrusher", "chorus", "echo"],
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 43,
					panDelay: 0,
					chorus: 43,
					echoSustain: 86,
					echoDelayBeats: 1.5,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					wave: "white",
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "Tambourine Noise",
				generalMidi: false,
				isNoise: true,
				tags: ["noise", "ashiiware"],
				settings: {
					type: "noise",
					eqFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 }],
					eqFilterType: true,
					eqSimpleCut: 8,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["detune", "note filter", "bitcrusher", "chorus"],
					detuneCents: -200,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 11.3137 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 11.3137 }],
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 0,
					panDelay: 10,
					chorus: 43,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "pink",
					unison: "none",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Sewer Drums",
				generalMidi: false,
				isNoise: true,
				tags: ["drumset", "ashiiware"],
				settings: {
					type: "drumset",
					eqFilter: [{ type: "low-pass", cutoffHz: 4240.89, linearGain: 2 }],
					eqFilterType: true,
					eqSimpleCut: 8,
					eqSimplePeak: 4,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["bitcrusher", "chorus", "reverb"],
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 29,
					panDelay: 10,
					chorus: 100,
					reverb: 0,
					drums: [
						{
							filterEnvelope: "twang 1",
							spectrum: [
								57, 71, 71, 86, 86, 86, 71, 71, 71, 71, 57, 57, 57, 57, 43, 43, 43,
								43, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29,
							],
						},
						{
							filterEnvelope: "twang 1",
							spectrum: [
								0, 0, 0, 100, 71, 71, 57, 86, 57, 57, 57, 71, 43, 43, 57, 43, 43,
								43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43,
							],
						},
						{
							filterEnvelope: "twang 1",
							spectrum: [
								0, 0, 0, 0, 100, 57, 43, 43, 29, 57, 43, 29, 71, 43, 43, 43, 43, 57,
								43, 43, 43, 43, 43, 43, 43, 43, 29, 43, 43, 43,
							],
						},
						{
							filterEnvelope: "twang 1",
							spectrum: [
								0, 0, 0, 0, 0, 71, 57, 43, 43, 43, 57, 57, 43, 29, 57, 43, 43, 43,
								29, 43, 57, 43, 43, 43, 43, 43, 43, 29, 43, 43,
							],
						},
						{
							filterEnvelope: "decay 2",
							spectrum: [
								0, 14, 29, 43, 86, 71, 29, 43, 43, 43, 43, 29, 71, 29, 71, 29, 43,
								43, 43, 43, 57, 43, 43, 57, 43, 43, 43, 57, 57, 57,
							],
						},
						{
							filterEnvelope: "decay 1",
							spectrum: [
								0, 0, 14, 14, 14, 14, 29, 29, 29, 43, 43, 43, 57, 57, 57, 71, 71,
								71, 71, 71, 71, 71, 71, 57, 57, 57, 57, 43, 43, 43,
							],
						},
						{
							filterEnvelope: "twang 3",
							spectrum: [
								43, 43, 43, 71, 29, 29, 43, 43, 43, 29, 43, 43, 43, 29, 29, 43, 43,
								29, 29, 29, 57, 14, 57, 43, 43, 57, 43, 43, 57, 57,
							],
						},
						{
							filterEnvelope: "decay 3",
							spectrum: [
								29, 43, 43, 43, 43, 29, 29, 43, 29, 29, 43, 29, 14, 29, 43, 29, 43,
								29, 57, 29, 43, 57, 43, 71, 43, 71, 57, 57, 71, 71,
							],
						},
						{
							filterEnvelope: "twang 3",
							spectrum: [
								43, 29, 29, 43, 29, 29, 29, 57, 29, 29, 29, 57, 43, 43, 29, 29, 57,
								43, 43, 43, 71, 43, 43, 71, 57, 71, 71, 71, 71, 71,
							],
						},
						{
							filterEnvelope: "decay 3",
							spectrum: [
								57, 57, 57, 43, 57, 57, 43, 43, 57, 43, 43, 43, 71, 57, 43, 57, 86,
								71, 57, 86, 71, 57, 86, 100, 71, 86, 86, 86, 86, 86,
							],
						},
						{
							filterEnvelope: "flare 1",
							spectrum: [
								0, 0, 14, 14, 14, 14, 29, 29, 29, 43, 43, 43, 57, 57, 71, 71, 86,
								86, 100, 100, 100, 100, 100, 100, 100, 100, 86, 57, 29, 0,
							],
						},
						{
							filterEnvelope: "decay 2",
							spectrum: [
								14, 14, 14, 14, 29, 14, 14, 29, 14, 43, 14, 43, 57, 86, 57, 57, 100,
								57, 43, 43, 57, 100, 57, 43, 29, 14, 0, 0, 0, 0,
							],
						},
					],
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "Radio Noise",
				generalMidi: false,
				isNoise: true,
				tags: ["noise", "ashiiware"],
				settings: {
					type: "noise",
					eqFilter: [{ type: "low-pass", cutoffHz: 7586.61, linearGain: 11.3137 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 7,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["chorus", "echo"],
					panDelay: 10,
					chorus: 100,
					echoSustain: 43,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "retro",
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "Starry Drums",
				generalMidi: false,
				isNoise: true,
				tags: ["noise", "ashiiware"],
				settings: {
					type: "noise",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["chorus"],
					panDelay: 10,
					chorus: 100,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "deep",
					unison: "stationary",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Hollow Hat",
				generalMidi: false,
				isNoise: true,
				tags: ["noise", "ashiiware"],
				settings: {
					type: "noise",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 6727.17, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 13454.34, linearGain: 11.3137 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 6727.17, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 13454.34, linearGain: 11.3137 },
					],
					eqSubFilters1: [],
					effects: ["pitch shift", "note filter"],
					pitchShiftSemitones: 24,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 297.3, linearGain: 0.25 },
						{
							type: "low-pass",
							cutoffHz: 3363.59,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 13454.34, linearGain: 11.3137 },
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 297.3, linearGain: 0.25 },
						{
							type: "low-pass",
							cutoffHz: 3363.59,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 13454.34, linearGain: 11.3137 },
					],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -24,
					wave: "hollow",
					unison: "none",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Dreamdrums",
				generalMidi: false,
				isNoise: true,
				tags: ["drumset", "ashiiware"],
				settings: {
					type: "drumset",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["bitcrusher", "echo"],
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 0,
					panDelay: 0,
					echoSustain: 71,
					echoDelayBeats: 1,
					drums: [
						{
							filterEnvelope: "twang 1",
							spectrum: [
								57, 71, 71, 86, 86, 86, 71, 71, 71, 71, 57, 57, 57, 57, 43, 43, 43,
								43, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29,
							],
						},
						{
							filterEnvelope: "twang 1",
							spectrum: [
								0, 0, 0, 100, 71, 71, 57, 86, 57, 57, 57, 71, 43, 43, 57, 43, 43,
								43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43,
							],
						},
						{
							filterEnvelope: "twang 1",
							spectrum: [
								0, 0, 0, 0, 100, 57, 43, 43, 29, 57, 43, 29, 71, 43, 43, 43, 43, 57,
								43, 43, 43, 43, 43, 43, 43, 43, 29, 43, 43, 43,
							],
						},
						{
							filterEnvelope: "twang 1",
							spectrum: [
								0, 0, 0, 0, 0, 71, 57, 43, 43, 43, 57, 57, 43, 29, 57, 43, 43, 43,
								29, 43, 57, 43, 43, 43, 43, 43, 43, 29, 43, 43,
							],
						},
						{
							filterEnvelope: "decay 2",
							spectrum: [
								0, 14, 29, 43, 86, 71, 29, 43, 43, 43, 43, 29, 71, 29, 71, 29, 43,
								43, 43, 43, 57, 43, 43, 57, 43, 43, 43, 57, 57, 57,
							],
						},
						{
							filterEnvelope: "decay 1",
							spectrum: [
								0, 0, 14, 14, 14, 14, 29, 29, 29, 43, 43, 43, 57, 57, 57, 71, 71,
								71, 71, 71, 71, 71, 71, 57, 57, 57, 57, 43, 43, 43,
							],
						},
						{
							filterEnvelope: "twang 3",
							spectrum: [
								43, 43, 43, 71, 29, 29, 43, 43, 43, 29, 43, 43, 43, 29, 29, 43, 43,
								29, 29, 29, 57, 14, 57, 43, 43, 57, 43, 43, 57, 57,
							],
						},
						{
							filterEnvelope: "decay 3",
							spectrum: [
								29, 43, 43, 43, 43, 29, 29, 43, 29, 29, 43, 29, 14, 29, 43, 29, 43,
								29, 57, 29, 43, 57, 43, 71, 43, 71, 57, 57, 71, 71,
							],
						},
						{
							filterEnvelope: "twang 3",
							spectrum: [
								43, 29, 29, 43, 29, 29, 29, 57, 29, 29, 29, 57, 43, 43, 29, 29, 57,
								43, 43, 43, 71, 43, 43, 71, 57, 71, 71, 71, 71, 71,
							],
						},
						{
							filterEnvelope: "decay 3",
							spectrum: [
								57, 57, 57, 43, 57, 57, 43, 43, 57, 43, 43, 43, 71, 57, 43, 57, 86,
								71, 57, 86, 71, 57, 86, 100, 71, 86, 86, 86, 86, 86,
							],
						},
						{
							filterEnvelope: "flare 1",
							spectrum: [
								0, 0, 14, 14, 14, 14, 29, 29, 29, 43, 43, 43, 57, 57, 71, 71, 86,
								86, 100, 100, 100, 100, 100, 100, 100, 100, 86, 57, 29, 0,
							],
						},
						{
							filterEnvelope: "decay 2",
							spectrum: [
								14, 14, 14, 14, 29, 14, 14, 29, 14, 43, 14, 43, 57, 86, 57, 57, 100,
								57, 43, 43, 57, 100, 57, 43, 29, 14, 0, 0, 0, 0,
							],
						},
					],
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "Spectrum Kick",
				generalMidi: false,
				isNoise: true,
				tags: ["spectrum", "ashiiware", "kick"],
				settings: {
					type: "spectrum",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chord type", "note filter"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: true,
					noteSimpleCut: 0,
					noteSimplePeak: 7,
					noteFilter: [{ type: "low-pass", cutoffHz: 250.03, linearGain: 11.3137 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 250.03, linearGain: 11.3137 }],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					spectrum: [
						0, 14, 29, 43, 43, 57, 86, 86, 71, 57, 57, 43, 43, 57, 86, 86, 43, 43, 71,
						57, 57, 57, 57, 57, 86, 86, 71, 71, 71, 71,
					],
					unison: "none",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Royalty Hollow",
				generalMidi: false,
				isNoise: true,
				tags: ["noise", "ashiiware"],
				settings: {
					type: "noise",
					eqFilter: [{ type: "low-pass", cutoffHz: 9140.55, linearGain: 2 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 3,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["reverb"],
					panDelay: 10,
					reverb: 87,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 72,
					wave: "hollow",
					unison: "none",
					envelopes: [],
				},
			},
		]),
	},
	{
		name: "Other Community Drum Presets",
		presets: toNameMap([
			{
				name: "something wicked - Cira",
				generalMidi: false,
				isNoise: true,
				tags: ["noise"],
				settings: {
					type: "noise",
					volume: 0,
					eqFilter: [{ type: "high-pass", cutoffHz: 594.6, linearGain: 0.0884 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 594.6, linearGain: 0.0884 }],
					effects: ["panning"],
					pan: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "hollow",
					unison: "none",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: true,
				},
			},
			{
				name: "Pink Noise Riser - The TuneCrusher",
				generalMidi: false,
				isNoise: true,
				tags: ["noise"],
				settings: {
					type: "noise",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.125 },
						{
							type: "high-pass",
							cutoffHz: 840.9,
							linearGain: 0.25,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.125 },
						{
							type: "high-pass",
							cutoffHz: 840.9,
							linearGain: 0.25,
						},
					],
					eqSubFilters1: [],
					effects: ["panning"],
					pan: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					wave: "pink",
					unison: "rising",
					envelopes: [
						{
							target: "unison",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: true,
						},
					],
					isDrum: true,
				},
			},
			{
				name: "Wind Ambience - The TuneCrusher",
				generalMidi: false,
				isNoise: true,
				tags: ["noise"],
				settings: {
					type: "noise",
					volume: 0,
					eqFilter: [{ type: "high-pass", cutoffHz: 250, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 250, linearGain: 0.7071 }],
					eqSubFilters1: [{ type: "low-pass", cutoffHz: 16000, linearGain: 1 }],
					effects: ["panning", "transition type", "note filter", "reverb"],
					transition: "continue",
					clicklessTransition: false,
					noteFilterType: true,
					noteSimpleCut: 0,
					noteSimplePeak: 7,
					noteFilter: [{ type: "low-pass", cutoffHz: 250.03, linearGain: 11.3137 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 250.03, linearGain: 11.3137 }],
					pan: 0,
					panDelay: 10,
					reverb: 68,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "white",
					unison: "resonance",
					envelopes: [
						{
							target: "panning",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.25,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 2,
							steps: 2,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: true,
				},
			},
			// -------------JukeBox 0.1.5 newcomers--------------
			{
				name: "Polynesian Drum - Yupekosi",
				generalMidi: false,
				isNoise: true,
				tags: ["spectrum"],
				settings: {
					type: "spectrum",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["pitch shift", "vibrato", "note filter"],
					pitchShiftSemitones: 6,
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.5 }],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					unison: "none",
					spectrum: [
						57, 71, 57, 86, 86, 100, 100, 86, 57, 57, 57, 43, 43, 43, 43, 29, 29, 29,
						14, 14, 14, 14, 14, 29, 29, 29, 14, 29, 14, 14,
					],
					envelopes: [
						{ target: "pitchShift", envelope: "twang 1" },
						{
							target: "noteFilterAllFreqs",
							envelope: "linear 3",
						},
					],
				},
			},
			// -------------JukeBox 0.1.6 newcomers--------------
			{
				name: "Shaky Wind - TheBloxer231",
				generalMidi: false,
				isNoise: true,
				tags: ["spectrum"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.0884 },
						{
							type: "high-pass",
							cutoffHz: 74.33,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 4756.83, linearGain: 2.8284 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.0884 },
						{
							type: "high-pass",
							cutoffHz: 74.33,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 4756.83, linearGain: 2.8284 },
					],
					eqSubFilters1: [{ type: "low-pass", cutoffHz: 16000, linearGain: 1 }],
					effects: ["vibrato", "granular", "chorus"],
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					granular: 4,
					grainSize: 49,
					grainAmounts: 10,
					grainRange: 40,
					chorus: 57,
					fadeInSeconds: 0.1575,
					fadeOutTicks: 96,
					spectrum: [
						86, 86, 100, 100, 100, 100, 100, 100, 100, 86, 86, 86, 71, 71, 71, 57, 57,
						57, 43, 43, 43, 43, 43, 29, 29, 29, 29, 43, 43, 100,
					],
					unison: "octave",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.3,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
						{
							target: "unison",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.08,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
						{
							target: "chorus",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 0.4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							steps: 32,
							seed: 34,
							waveform: 0,
						},
					],
				},
			},
			{
				name: "Alternate Drumset - CoolTasDude",
				generalMidi: false,
				isNoise: true,
				tags: ["drumset", "cooltasdude"],
				settings: {
					type: "drumset",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 6,
					eqSubFilters0: [],
					effects: ["transition type", "note filter", "reverb"],
					transition: "normal",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 1 }],
					panDelay: 0,
					reverb: 16,
					drums: [
						{
							filterEnvelope: "none",
							spectrum: [
								0, 43, 0, 71, 43, 100, 100, 29, 57, 14, 86, 29, 14, 100, 14, 29, 71,
								43, 0, 29, 71, 29, 0, 29, 14, 0, 0, 0, 29, 0,
							],
						},
						{
							filterEnvelope: "twang 1",
							spectrum: [
								86, 29, 86, 14, 57, 57, 57, 57, 100, 100, 57, 0, 29, 71, 14, 71,
								100, 0, 29, 86, 0, 29, 71, 14, 43, 14, 71, 57, 14, 86,
							],
						},
						{
							filterEnvelope: "flare 2",
							spectrum: [
								43, 14, 71, 29, 43, 0, 57, 29, 71, 0, 29, 29, 57, 0, 71, 0, 57, 43,
								0, 14, 71, 0, 71, 29, 100, 0, 100, 57, 86, 86,
							],
						},
						{
							filterEnvelope: "flutter 2",
							spectrum: [
								0, 29, 14, 14, 29, 14, 0, 0, 0, 0, 100, 43, 29, 100, 0, 0, 0, 29, 0,
								0, 14, 14, 14, 43, 14, 0, 100, 0, 0, 14,
							],
						},
						{
							filterEnvelope: "flute 1",
							spectrum: [
								29, 0, 43, 86, 14, 0, 57, 57, 86, 86, 100, 86, 14, 57, 57, 71, 71,
								29, 0, 14, 100, 0, 71, 0, 71, 43, 29, 29, 14, 14,
							],
						},
						{
							filterEnvelope: "flare 3",
							spectrum: [
								100, 14, 86, 57, 0, 0, 14, 43, 100, 29, 29, 100, 0, 43, 57, 14, 86,
								43, 86, 71, 14, 57, 14, 0, 14, 86, 0, 57, 43, 0,
							],
						},
						{
							filterEnvelope: "decay 2",
							spectrum: [
								29, 71, 43, 14, 43, 14, 29, 14, 14, 14, 29, 71, 86, 71, 86, 100, 86,
								57, 43, 57, 29, 43, 0, 0, 0, 43, 0, 0, 0, 14,
							],
						},
						{
							filterEnvelope: "tripolo5",
							spectrum: [
								0, 0, 43, 0, 29, 0, 29, 0, 100, 43, 29, 29, 0, 57, 0, 0, 29, 14, 86,
								71, 43, 14, 71, 14, 71, 71, 0, 57, 86, 57,
							],
						},
						{
							filterEnvelope: "linear 2",
							spectrum: [
								71, 29, 86, 0, 14, 0, 86, 0, 57, 57, 0, 86, 86, 29, 14, 0, 71, 29,
								71, 71, 57, 0, 57, 86, 71, 57, 100, 29, 100, 71,
							],
						},
						{
							filterEnvelope: "decay 2",
							spectrum: [
								0, 86, 29, 14, 57, 0, 0, 86, 0, 29, 14, 29, 0, 43, 57, 100, 0, 71,
								43, 57, 14, 86, 0, 57, 43, 43, 0, 29, 14, 71,
							],
						},
						{
							filterEnvelope: "linear 2",
							spectrum: [
								57, 0, 86, 100, 0, 43, 57, 14, 57, 14, 14, 57, 43, 71, 71, 29, 29,
								14, 43, 29, 43, 14, 43, 43, 14, 57, 0, 0, 29, 57,
							],
						},
						{
							filterEnvelope: "pitch",
							spectrum: [
								71, 0, 29, 0, 29, 14, 71, 0, 86, 0, 43, 29, 14, 71, 29, 0, 100, 14,
								14, 14, 29, 43, 43, 0, 100, 0, 14, 14, 29, 14,
							],
						},
					],
					unison: "none",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 6.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			// -------------JukeBox 0.2.0 presets--------------
			{
				name: "drums of agony - snowirei",
				generalMidi: false,
				isNoise: true,
				tags: ["drumset", "snowirei"],
				settings: {
					type: "drumset",
					eqFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 }],
					eqFilterType: true,
					eqSimpleCut: 8,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["distortion"],
					distortion: 86,
					aliases: false,
					panDelay: 0,
					drums: [
						{
							filterEnvelope: "twang 1",
							spectrum: [
								0, 0, 0, 71, 100, 71, 71, 71, 71, 86, 86, 71, 57, 43, 57, 71, 71,
								71, 71, 71, 71, 71, 43, 43, 43, 43, 43, 43, 43, 100,
							],
						},
						{
							filterEnvelope: "rise 3",
							spectrum: [
								0, 0, 0, 100, 71, 57, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
								0, 0, 0, 0, 0, 0, 0, 0, 0,
							],
						},
						{
							filterEnvelope: "punch",
							spectrum: [
								0, 0, 0, 0, 100, 57, 43, 43, 29, 0, 0, 0, 0, 0, 14, 14, 14, 14, 14,
								14, 29, 29, 14, 14, 0, 0, 14, 29, 43, 57,
							],
						},
						{
							filterEnvelope: "twang 2",
							spectrum: [
								0, 0, 0, 0, 0, 71, 57, 43, 43, 43, 57, 57, 43, 29, 57, 43, 43, 43,
								29, 43, 57, 43, 43, 43, 43, 43, 43, 29, 43, 43,
							],
						},
						{
							filterEnvelope: "decay 2",
							spectrum: [
								71, 100, 100, 0, 0, 100, 100, 100, 100, 0, 100, 100, 100, 100, 0,
								57, 86, 100, 100, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
							],
						},
						{
							filterEnvelope: "decay 1",
							spectrum: [
								0, 0, 14, 14, 14, 14, 29, 29, 29, 43, 0, 0, 57, 57, 57, 71, 71, 71,
								71, 71, 14, 14, 14, 14, 14, 0, 57, 43, 43, 43,
							],
						},
						{
							filterEnvelope: "punch",
							spectrum: [
								43, 43, 71, 71, 71, 86, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
								57, 71, 71, 71, 71, 71, 0, 0, 0,
							],
						},
						{
							filterEnvelope: "decay 2",
							spectrum: [
								100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,
								100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,
								100, 100, 100, 100,
							],
						},
						{
							filterEnvelope: "swell 1",
							spectrum: [
								14, 29, 29, 29, 43, 43, 43, 57, 14, 14, 14, 14, 14, 29, 43, 57, 71,
								86, 100, 0, 14, 29, 57, 0, 0, 0, 0, 0, 0, 86,
							],
						},
						{
							filterEnvelope: "decay 3",
							spectrum: [
								0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 14, 0, 0, 0, 0,
								0, 0, 0, 0, 0, 0, 0, 0,
							],
						},
						{
							filterEnvelope: "flare 1",
							spectrum: [
								0, 0, 0, 0, 0, 0, 43, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
								0, 0, 0, 0, 0, 0, 0, 0,
							],
						},
						{
							filterEnvelope: "decay 2",
							spectrum: [
								0, 0, 0, 100, 0, 0, 0, 100, 0, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
								0, 0, 0, 0, 0, 0, 0, 0, 0,
							],
						},
					],
					envelopes: [],
				},
			},
			// -------------JukeBox 0.2.3 presets--------------
			{
				name: "Jungle Drums - SuP3r",
				generalMidi: false,
				isNoise: true,
				tags: ["drumset", "sup3r"],
				settings: {
					type: "drumset",
					eqFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 }],
					eqFilterType: true,
					eqSimpleCut: 8,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["note filter", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.5 }],
					panDelay: 0,
					reverb: 13,
					drums: [
						{
							filterEnvelope: "twang 1",
							spectrum: [
								57, 29, 57, 0, 29, 0, 0, 57, 86, 43, 43, 14, 14, 0, 100, 0, 0, 14,
								71, 0, 14, 86, 57, 71, 57, 14, 14, 43, 0, 14,
							],
						},
						{
							filterEnvelope: "decay -1",
							spectrum: [
								57, 29, 0, 71, 86, 0, 29, 0, 29, 100, 0, 14, 14, 71, 29, 86, 57, 43,
								57, 0, 0, 57, 0, 86, 100, 71, 14, 14, 0, 71,
							],
						},
						{
							filterEnvelope: "flute 2",
							spectrum: [
								14, 0, 0, 0, 57, 0, 29, 0, 29, 29, 29, 29, 0, 14, 0, 29, 100, 14,
								43, 29, 86, 43, 71, 0, 29, 14, 14, 86, 29, 0,
							],
						},
						{
							filterEnvelope: "wibble-1",
							spectrum: [
								57, 14, 57, 0, 57, 57, 57, 71, 0, 0, 86, 14, 71, 14, 43, 14, 57, 71,
								43, 29, 29, 71, 100, 29, 14, 14, 29, 0, 57, 100,
							],
						},
						{
							filterEnvelope: "pentolo3",
							spectrum: [
								0, 57, 29, 57, 71, 100, 100, 0, 86, 14, 14, 14, 100, 57, 86, 0, 71,
								14, 14, 14, 29, 57, 0, 14, 0, 86, 57, 100, 43, 86,
							],
						},
						{
							filterEnvelope: "flute 2",
							spectrum: [
								0, 0, 29, 29, 0, 57, 0, 0, 14, 14, 14, 57, 14, 71, 14, 86, 0, 0, 14,
								14, 29, 0, 0, 57, 71, 0, 100, 29, 43, 57,
							],
						},
						{
							filterEnvelope: "linear 2",
							spectrum: [
								71, 0, 57, 29, 29, 57, 86, 0, 29, 29, 29, 14, 29, 100, 14, 57, 14,
								14, 57, 57, 57, 14, 0, 14, 14, 0, 71, 71, 14, 0,
							],
						},
						{
							filterEnvelope: "flare 1",
							spectrum: [
								0, 57, 14, 14, 43, 43, 0, 57, 0, 29, 29, 86, 14, 29, 0, 0, 0, 86, 0,
								57, 14, 100, 43, 0, 100, 0, 86, 0, 57, 71,
							],
						},
						{
							filterEnvelope: "rise -1",
							spectrum: [
								29, 14, 0, 0, 0, 71, 0, 57, 14, 14, 43, 0, 0, 86, 14, 0, 29, 29, 14,
								43, 86, 43, 14, 0, 100, 43, 0, 43, 0, 0,
							],
						},
						{
							filterEnvelope: "tremolo2",
							spectrum: [
								0, 0, 43, 14, 0, 0, 14, 100, 57, 57, 14, 14, 0, 0, 14, 57, 0, 71, 0,
								43, 0, 57, 100, 0, 0, 86, 57, 0, 29, 0,
							],
						},
						{
							filterEnvelope: "tripolo5",
							spectrum: [
								0, 0, 14, 0, 0, 14, 0, 86, 14, 14, 0, 0, 100, 71, 0, 71, 29, 57, 14,
								14, 0, 0, 14, 0, 43, 0, 71, 14, 0, 86,
							],
						},
						{
							filterEnvelope: "linear 1",
							spectrum: [
								0, 14, 0, 0, 100, 57, 57, 86, 57, 0, 86, 0, 14, 14, 14, 0, 14, 29,
								14, 0, 29, 71, 86, 0, 0, 0, 57, 57, 29, 57,
							],
						},
					],
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "punch" }],
				},
			},
			{
				name: "Steel Breath - SuP3r",
				generalMidi: false,
				isNoise: true,
				tags: ["spectrum", "sup3r"],
				settings: {
					type: "spectrum",
					eqFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 }],
					eqFilterType: true,
					eqSimpleCut: 8,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["note filter"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 1 }],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					spectrum: [
						100, 0, 29, 57, 14, 43, 29, 14, 29, 29, 14, 0, 14, 0, 14, 14, 29, 29, 29, 0,
						14, 14, 0, 14, 29, 0, 29, 14, 0, 14,
					],
					unison: "none",
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "linear 3" }],
				},
			},
			{
				name: "Master Drumset - StapyThePinoy",
				generalMidi: false,
				isNoise: true,
				tags: ["drumset"],
				settings: {
					type: "drumset",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 250,
							linearGain: 0.7071,
						},
						{ type: "peak", cutoffHz: 1681.79, linearGain: 2.8284 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 250,
							linearGain: 0.7071,
						},
						{ type: "peak", cutoffHz: 1681.79, linearGain: 2.8284 },
					],
					effects: ["vibrato", "note filter", "distortion", "chorus"],
					vibrato: "none",
					vibratoDepth: 0,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					distortion: 0,
					aliases: false,
					panDelay: 0,
					chorus: 0,
					drums: [
						{
							filterEnvelope: "twang 1",
							spectrum: [
								43, 57, 71, 86, 100, 100, 100, 100, 100, 100, 86, 86, 86, 71, 71,
								57, 57, 43, 43, 29, 29, 14, 14, 0, 0, 0, 0, 0, 0, 0,
							],
						},
						{
							filterEnvelope: "twang 1",
							spectrum: [
								0, 0, 0, 100, 43, 86, 86, 100, 100, 100, 100, 100, 86, 86, 86, 71,
								71, 57, 57, 57, 57, 57, 57, 57, 57, 57, 57, 43, 43, 43,
							],
						},
						{
							filterEnvelope: "twang 1",
							spectrum: [
								0, 0, 0, 43, 71, 86, 86, 86, 86, 71, 57, 57, 57, 43, 43, 43, 43, 43,
								43, 43, 43, 43, 43, 43, 43, 43, 43, 29, 29, 14,
							],
						},
						{
							filterEnvelope: "twang 1",
							spectrum: [
								0, 0, 0, 0, 14, 29, 57, 57, 71, 86, 86, 86, 86, 86, 86, 86, 86, 71,
								71, 71, 57, 57, 43, 43, 29, 14, 0, 0, 0, 0,
							],
						},
						{
							filterEnvelope: "decay 2",
							spectrum: [
								0, 14, 57, 71, 86, 86, 86, 86, 71, 71, 43, 43, 29, 43, 57, 57, 71,
								71, 71, 71, 57, 57, 43, 43, 43, 43, 43, 43, 43, 71,
							],
						},
						{
							filterEnvelope: "decay 1",
							spectrum: [
								0, 0, 14, 0, 0, 14, 14, 29, 43, 43, 43, 57, 57, 71, 71, 71, 71, 71,
								71, 71, 57, 57, 57, 43, 43, 43, 43, 43, 29, 0,
							],
						},
						{
							filterEnvelope: "twang 3",
							spectrum: [
								29, 43, 43, 43, 43, 57, 57, 57, 57, 57, 43, 43, 43, 43, 43, 29, 29,
								29, 29, 29, 29, 29, 43, 43, 43, 43, 43, 43, 57, 57,
							],
						},
						{
							filterEnvelope: "decay 3",
							spectrum: [
								0, 14, 43, 43, 43, 43, 43, 43, 43, 29, 43, 43, 71, 71, 57, 57, 57,
								57, 57, 57, 57, 57, 43, 43, 43, 57, 71, 71, 86, 100,
							],
						},
						{
							filterEnvelope: "twang 3",
							spectrum: [
								43, 43, 43, 57, 57, 57, 57, 57, 57, 57, 57, 57, 57, 57, 57, 57, 57,
								57, 57, 57, 57, 57, 71, 71, 86, 86, 86, 86, 86, 57,
							],
						},
						{
							filterEnvelope: "decay 3",
							spectrum: [
								29, 43, 43, 43, 43, 43, 43, 43, 43, 43, 71, 71, 71, 71, 57, 57, 43,
								71, 71, 71, 71, 71, 57, 57, 57, 57, 57, 57, 57, 86,
							],
						},
						{
							filterEnvelope: "flare 1",
							spectrum: [
								0, 0, 14, 29, 43, 43, 57, 57, 71, 71, 71, 71, 86, 86, 86, 86, 100,
								100, 100, 100, 100, 100, 86, 86, 71, 57, 43, 43, 29, 14,
							],
						},
						{
							filterEnvelope: "decay 2",
							spectrum: [
								14, 14, 14, 29, 43, 43, 57, 71, 71, 71, 71, 71, 86, 86, 86, 86, 86,
								86, 86, 86, 86, 86, 71, 57, 43, 29, 14, 14, 0, 0,
							],
						},
					],
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "Claves - Formskooooo",
				generalMidi: false,
				isNoise: true,
				tags: ["spectrum", "formskooooo"],
				settings: {
					type: "spectrum",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chord type", "note filter", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: true,
					noteSimpleCut: 7,
					noteSimplePeak: 1,
					noteFilter: [{ type: "low-pass", cutoffHz: 3828.43, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 3828.43, linearGain: 0.5 }],
					panDelay: 0,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					spectrum: [
						0, 0, 0, 14, 71, 71, 71, 14, 29, 43, 100, 100, 43, 0, 14, 0, 0, 0, 0, 0, 0,
						0, 0, 0, 0, 0, 0, 0, 0, 0,
					],
					unison: "none",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Drumcrush - Jayden256",
				generalMidi: false,
				isNoise: true,
				tags: ["drumset", "featured"],
				settings: {
					type: "drumset",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["pitch shift", "distortion", "bitcrusher"],
					pitchShiftSemitones: 9,
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 43,
					panDelay: 0,
					drums: [
						{
							filterEnvelope: "twang 1",
							spectrum: [
								100, 86, 86, 86, 71, 71, 71, 71, 57, 57, 57, 57, 57, 43, 43, 43, 43,
								43, 43, 29, 29, 29, 29, 29, 29, 29, 14, 14, 14, 0,
							],
						},
						{
							filterEnvelope: "twang 1",
							spectrum: [
								71, 71, 71, 71, 71, 71, 71, 71, 71, 71, 71, 71, 71, 71, 71, 71, 71,
								71, 57, 57, 57, 57, 57, 57, 57, 57, 57, 57, 57, 57,
							],
						},
						{
							filterEnvelope: "twang 1",
							spectrum: [
								0, 0, 57, 57, 57, 57, 71, 71, 71, 71, 71, 86, 86, 86, 86, 100, 100,
								100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,
							],
						},
						{
							filterEnvelope: "twang 1",
							spectrum: [
								43, 43, 43, 57, 57, 57, 57, 57, 71, 71, 71, 71, 86, 86, 86, 86, 86,
								100, 100, 71, 71, 71, 71, 57, 57, 57, 57, 57, 43, 43,
							],
						},
						{
							filterEnvelope: "decay 2",
							spectrum: [
								57, 57, 57, 57, 57, 57, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43,
								43, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 0,
							],
						},
						{
							filterEnvelope: "decay 1",
							spectrum: [
								43, 57, 57, 57, 57, 57, 57, 57, 57, 71, 71, 71, 71, 71, 71, 71, 71,
								71, 71, 86, 86, 86, 86, 86, 86, 86, 86, 86, 100, 100,
							],
						},
						{
							filterEnvelope: "twang 3",
							spectrum: [
								43, 43, 14, 43, 43, 0, 43, 43, 71, 71, 100, 43, 43, 14, 71, 43, 43,
								0, 71, 86, 57, 57, 14, 57, 14, 57, 57, 86, 14, 57,
							],
						},
						{
							filterEnvelope: "decay 3",
							spectrum: [
								29, 29, 29, 29, 43, 43, 43, 57, 57, 57, 57, 57, 57, 57, 43, 29, 43,
								29, 57, 29, 43, 57, 43, 71, 43, 71, 57, 57, 71, 71,
							],
						},
						{
							filterEnvelope: "twang 3",
							spectrum: [
								0, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 29, 29,
								29, 29, 43, 43, 43, 57, 57, 57, 57, 57, 57, 57, 71,
							],
						},
						{
							filterEnvelope: "decay 3",
							spectrum: [
								57, 43, 43, 43, 57, 57, 57, 57, 71, 71, 71, 0, 0, 29, 43, 57, 86,
								71, 57, 86, 71, 57, 86, 100, 71, 86, 86, 86, 86, 86,
							],
						},
						{
							filterEnvelope: "fall 2",
							spectrum: [
								29, 57, 57, 57, 57, 57, 57, 57, 57, 57, 57, 57, 57, 57, 57, 57, 57,
								57, 57, 57, 57, 57, 57, 57, 57, 57, 57, 57, 43, 86,
							],
						},
						{
							filterEnvelope: "decay 2",
							spectrum: [
								14, 14, 14, 14, 29, 14, 43, 57, 57, 57, 57, 71, 71, 71, 71, 71, 71,
								71, 86, 86, 86, 86, 86, 86, 86, 86, 100, 100, 100, 100,
							],
						},
					],
					unison: "vibrate",
					envelopes: [],
				},
			},
			{
				name: "Buried Noise - Jayden256",
				generalMidi: false,
				isNoise: true,
				tags: ["noise"],
				settings: {
					type: "noise",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 88.39,
							linearGain: 11.3137,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 88.39,
							linearGain: 11.3137,
						},
					],
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "white",
					unison: "buried",
					envelopes: [],
				},
			},
			{
				name: "Wind... - Jayden256",
				generalMidi: false,
				isNoise: true,
				tags: ["noise"],
				settings: {
					type: "noise",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 2000,
							linearGain: 1,
						},
						{ type: "peak", cutoffHz: 4000, linearGain: 0.5 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 2000,
							linearGain: 1,
						},
						{ type: "peak", cutoffHz: 4000, linearGain: 0.5 },
					],
					effects: ["note filter", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 420.45,
							linearGain: 1,
						},
						{ type: "peak", cutoffHz: 840.9, linearGain: 1 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 420.45,
							linearGain: 1,
						},
						{ type: "peak", cutoffHz: 840.9, linearGain: 1 },
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 1681.79, linearGain: 0.5 }],
					panDelay: 0,
					reverb: 6,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 12,
					wave: "brownian",
					unison: "block",
					envelopes: [],
				},
			},
			{
				name: "Alt Woodblock - Jayden256",
				generalMidi: false,
				isNoise: true,
				tags: ["spectrum"],
				settings: {
					type: "spectrum",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chord type", "note filter", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: true,
					noteSimpleCut: 7,
					noteSimplePeak: 1,
					noteFilter: [{ type: "low-pass", cutoffHz: 3828.43, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 3828.43, linearGain: 0.5 }],
					panDelay: 0,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					spectrum: [
						43, 57, 29, 14, 43, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 14, 14,
						14, 14, 14, 14, 14, 14, 0, 0, 0, 0, 0,
					],
					unison: "none",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Bass Drum - Jayden256",
				generalMidi: false,
				isNoise: true,
				tags: ["spectrum"],
				settings: {
					type: "spectrum",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chord type", "note filter", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: true,
					noteSimpleCut: 7,
					noteSimplePeak: 3,
					noteFilter: [{ type: "low-pass", cutoffHz: 3049.17, linearGain: 1.4142 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 3049.17, linearGain: 1.4142 }],
					panDelay: 0,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					spectrum: [
						43, 43, 57, 71, 86, 86, 100, 100, 100, 86, 86, 86, 71, 71, 71, 57, 57, 57,
						43, 43, 43, 29, 29, 29, 14, 14, 14, 43, 43, 57,
					],
					unison: "none",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Noise Snare - Jayden256",
				generalMidi: false,
				isNoise: true,
				tags: ["spectrum", "snare"],
				settings: {
					type: "spectrum",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["pitch shift", "detune", "distortion", "bitcrusher"],
					pitchShiftSemitones: 0,
					detuneCents: -200,
					distortion: 100,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 100,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					spectrum: [
						100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,
						100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,
					],
					unison: "block",
					envelopes: [],
				},
			},
			{
				name: "Drum Synth 2 - Jayden256",
				generalMidi: false,
				isNoise: true,
				tags: ["noise"],
				settings: {
					type: "noise",
					eqFilter: [{ type: "peak", cutoffHz: 250, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "peak", cutoffHz: 250, linearGain: 0.7071 }],
					eqSubFilters1: [],
					effects: ["bitcrusher", "chorus"],
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 14,
					panDelay: 0,
					chorus: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					wave: "clang",
					unison: "extraterrestrial",
					envelopes: [],
				},
			},
			{
				name: "Mustdense Drums - SprinklekitOrion",
				isNoise: true,
				generalMidi: false,
				tags: ["drumset"],
				settings: {
					type: "drumset",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["reverb"],
					panDelay: 0,
					reverb: 0,
					drums: [
						{
							filterEnvelope: "twang 1",
							spectrum: [
								57, 57, 57, 57, 57, 57, 57, 57, 57, 57, 57, 57, 57, 57, 0, 0, 0, 0,
								0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
							],
						},
						{
							filterEnvelope: "twang 1",
							spectrum: [
								29, 29, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 29, 29, 14, 14, 0,
								0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
							],
						},
						{
							filterEnvelope: "twang 1",
							spectrum: [
								29, 43, 43, 43, 43, 43, 43, 43, 43, 43, 29, 29, 29, 14, 14, 0, 0, 0,
								0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
							],
						},
						{
							filterEnvelope: "twang 1",
							spectrum: [
								43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 29, 29, 29, 0, 0, 0, 0,
								0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
							],
						},
						{
							filterEnvelope: "decay 2",
							spectrum: [
								71, 71, 71, 71, 71, 71, 71, 71, 71, 71, 71, 71, 71, 71, 71, 71, 71,
								71, 71, 71, 71, 71, 71, 71, 71, 71, 71, 71, 71, 71,
							],
						},
						{
							filterEnvelope: "decay 1",
							spectrum: [
								100, 29, 14, 29, 29, 29, 29, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43,
								43, 43, 43, 43, 100, 100, 100, 100, 100, 100, 100, 100, 100,
							],
						},
						{
							filterEnvelope: "twang 3",
							spectrum: [
								14, 14, 29, 29, 29, 29, 29, 29, 29, 43, 43, 57, 57, 57, 71, 71, 71,
								71, 71, 71, 86, 100, 100, 100, 100, 100, 100, 86, 100, 100,
							],
						},
						{
							filterEnvelope: "decay 3",
							spectrum: [
								0, 29, 29, 29, 29, 29, 29, 43, 43, 43, 43, 57, 57, 57, 71, 71, 71,
								71, 71, 71, 71, 100, 100, 100, 100, 100, 100, 100, 100, 100,
							],
						},
						{
							filterEnvelope: "twang 3",
							spectrum: [
								0, 14, 57, 43, 29, 43, 29, 29, 29, 43, 43, 43, 43, 43, 43, 43, 43,
								57, 57, 86, 86, 86, 100, 100, 100, 100, 100, 100, 100, 100,
							],
						},
						{
							filterEnvelope: "decay 3",
							spectrum: [
								0, 29, 29, 29, 29, 43, 43, 43, 43, 43, 57, 57, 57, 71, 71, 86, 86,
								100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 14,
							],
						},
						{
							filterEnvelope: "flare 1",
							spectrum: [
								0, 0, 14, 14, 14, 14, 29, 29, 29, 43, 43, 43, 57, 57, 71, 71, 86,
								86, 100, 100, 100, 100, 100, 100, 100, 100, 86, 57, 29, 0,
							],
						},
						{
							filterEnvelope: "decay 2",
							spectrum: [
								14, 0, 0, 43, 29, 29, 29, 29, 29, 43, 43, 57, 57, 57, 57, 71, 71,
								71, 86, 86, 86, 86, 86, 86, 86, 86, 71, 43, 29, 14,
							],
						},
					],
					unison: "none",
					envelopes: [],
				},
			},
			// -------------JukeBox 0.2.4 presets--------------
			{
				name: "actually good drumkit - UBF33",
				generalMidi: false,
				isNoise: true,
				tags: ["drumset"],
				settings: {
					type: "drumset",
					eqFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 }],
					eqFilterType: true,
					eqSimpleCut: 8,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					drums: [
						{
							filterEnvelope: "flutter 1",
							spectrum: [
								0, 0, 0, 0, 14, 100, 86, 0, 43, 14, 43, 0, 43, 0, 14, 29, 86, 29,
								29, 14, 86, 100, 14, 57, 0, 29, 71, 0, 43, 14,
							],
						},
						{
							filterEnvelope: "twang 2",
							spectrum: [
								71, 14, 100, 0, 0, 0, 0, 0, 0, 14, 14, 100, 57, 0, 14, 14, 14, 43,
								14, 14, 0, 14, 43, 0, 57, 14, 43, 0, 100, 71,
							],
						},
						{
							filterEnvelope: "tremolo1",
							spectrum: [
								29, 29, 0, 43, 0, 14, 29, 14, 71, 71, 0, 29, 100, 0, 0, 71, 14, 57,
								14, 29, 0, 71, 14, 43, 100, 71, 86, 100, 57, 71,
							],
						},
						{
							filterEnvelope: "tremolo2",
							spectrum: [
								43, 57, 100, 0, 43, 14, 100, 57, 0, 100, 14, 57, 0, 14, 14, 14, 29,
								0, 71, 86, 0, 57, 0, 0, 29, 0, 71, 0, 29, 43,
							],
						},
						{
							filterEnvelope: "punch",
							spectrum: [
								14, 43, 43, 71, 14, 57, 0, 0, 86, 0, 86, 100, 29, 86, 0, 57, 71, 57,
								86, 43, 100, 14, 43, 29, 0, 43, 43, 29, 86, 0,
							],
						},
						{
							filterEnvelope: "twang -1",
							spectrum: [
								57, 29, 86, 14, 29, 0, 14, 71, 14, 0, 14, 57, 57, 14, 71, 86, 43,
								100, 71, 57, 14, 43, 29, 43, 14, 86, 29, 29, 0, 71,
							],
						},
						{
							filterEnvelope: "rise 1",
							spectrum: [
								0, 100, 43, 43, 86, 86, 71, 29, 100, 86, 14, 57, 14, 0, 0, 14, 14,
								29, 0, 86, 0, 57, 29, 71, 0, 71, 57, 14, 57, 71,
							],
						},
						{
							filterEnvelope: "pentolo2",
							spectrum: [
								0, 43, 86, 0, 14, 29, 14, 0, 43, 0, 29, 0, 43, 43, 0, 14, 57, 0, 71,
								71, 0, 100, 29, 29, 0, 0, 86, 100, 14, 100,
							],
						},
						{
							filterEnvelope: "flutter 1",
							spectrum: [
								14, 86, 57, 14, 0, 0, 14, 43, 0, 14, 43, 14, 14, 86, 0, 29, 57, 29,
								43, 0, 57, 86, 14, 100, 71, 86, 43, 0, 0, 0,
							],
						},
						{
							filterEnvelope: "wibble 3",
							spectrum: [
								100, 0, 0, 43, 57, 43, 43, 57, 0, 57, 0, 0, 14, 71, 0, 43, 86, 71,
								14, 71, 57, 57, 14, 43, 0, 0, 100, 0, 0, 0,
							],
						},
						{
							filterEnvelope: "rise 2",
							spectrum: [
								14, 0, 0, 14, 43, 14, 0, 100, 86, 86, 57, 29, 43, 29, 0, 43, 86, 14,
								43, 57, 86, 29, 0, 71, 0, 0, 0, 14, 86, 71,
							],
						},
						{
							filterEnvelope: "rise 3",
							spectrum: [
								100, 14, 14, 14, 29, 14, 57, 29, 57, 29, 57, 57, 0, 86, 14, 71, 57,
								0, 0, 14, 0, 0, 14, 0, 14, 29, 43, 14, 29, 100,
							],
						},
					],
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "Gong - Formskooooo",
				generalMidi: false,
				isNoise: true,
				tags: ["spectrum", "formskooooo"],
				settings: {
					type: "spectrum",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 2,
					eqSubFilters0: [],
					effects: ["note filter", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 1 }],
					panDelay: 0,
					reverb: 16,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					spectrum: [
						43, 14, 71, 29, 43, 0, 57, 29, 71, 0, 29, 29, 57, 0, 71, 0, 57, 43, 0, 14,
						71, 0, 71, 29, 100, 0, 100, 57, 86, 86,
					],
					unison: "none",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 6.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Ceng Cengs - Formskooooo",
				generalMidi: false,
				isNoise: true,
				tags: ["spectrum", "formskooooo"],
				settings: {
					type: "spectrum",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -24,
					spectrum: [
						0, 0, 29, 43, 86, 71, 29, 43, 43, 43, 43, 29, 71, 29, 71, 29, 43, 43, 43,
						43, 43, 43, 0, 29, 0, 43, 43, 57, 57, 57,
					],
					unison: "none",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Strange Sound - Jayden256",
				generalMidi: false,
				isNoise: true,
				tags: ["spectrum"],
				settings: {
					type: "spectrum",
					eqFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1 }],
					effects: ["note filter", "bitcrusher", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 11.3137 },
						{
							type: "low-pass",
							cutoffHz: 4000,
							linearGain: 0.0884,
						},
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 11.3137 },
						{
							type: "low-pass",
							cutoffHz: 4000,
							linearGain: 0.0884,
						},
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1.4142 }],
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 0,
					panDelay: 0,
					reverb: 13,
					fadeInSeconds: 0.1575,
					fadeOutTicks: 96,
					spectrum: [
						100, 71, 71, 57, 43, 43, 43, 29, 57, 29, 71, 29, 86, 86, 29, 57, 29, 29, 86,
						14, 14, 14, 29, 29, 43, 43, 43, 86, 57, 57,
					],
					unison: "inject",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "wibble",
							inverse: false,
							perEnvelopeSpeed: 19,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			// -------------JukeBox 0.3.0 presets--------------
			{
				name: "Deep Crush - Jayden256",
				generalMidi: false,
				isNoise: true,
				tags: ["noise"],
				settings: {
					type: "noise",
					eqFilter: [{ type: "low-pass", cutoffHz: 2000, linearGain: 0.0884 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 2000, linearGain: 0.0884 }],
					effects: ["bitcrusher", "chorus"],
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 0,
					panDelay: 0,
					chorus: 43,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					wave: "deep",
					unison: "weird octave",
					envelopes: [],
				},
			},
			{
				name: "Knock on wood - jacobis12344",
				generalMidi: false,
				isNoise: true,
				tags: ["spectrum", "drum"],
				settings: {
					type: "spectrum",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chord type", "vibrato", "note filter"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 62.5,
							linearGain: 11.3137,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 62.5,
							linearGain: 11.3137,
						},
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 1414.21, linearGain: 1 }],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					spectrum: [
						0, 43, 57, 86, 86, 100, 57, 71, 71, 71, 86, 86, 86, 86, 86, 86, 86, 86, 86,
						86, 86, 71, 71, 71, 71, 14, 86, 57, 29, 0,
					],
					unison: "shimmer",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Whooshing - Luxian",
				generalMidi: false,
				isNoise: true,
				tags: ["spectrum", "drum"],
				settings: {
					type: "spectrum",
					eqFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 }],
					eqFilterType: true,
					eqSimpleCut: 8,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["note filter", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.125 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.125 }],
					panDelay: 10,
					reverb: 3,
					fadeInSeconds: 0.0413,
					fadeOutTicks: -1,
					unison: "none",
					spectrum: [
						71, 57, 57, 57, 86, 71, 57, 43, 43, 43, 43, 43, 43, 71, 71, 57, 86, 100, 71,
						86, 71, 43, 43, 43, 43, 43, 29, 29, 29, 14,
					],
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "tremolo2" }],
				},
			},
			{
				name: "sweep shaker - dragoncoder047",
				generalMidi: false,
				isNoise: true,
				tags: ["noise", "dragoncoder047"],
				settings: {
					type: "noise",
					eqFilter: [{ type: "peak", cutoffHz: 1189.21, linearGain: 11.3137 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 6,
					eqSubFilters0: [{ type: "peak", cutoffHz: 1189.21, linearGain: 11.3137 }],
					eqSubFilters1: [{ type: "peak", cutoffHz: 4000, linearGain: 11.3137 }],
					eqSubFilters2: [{ type: "peak", cutoffHz: 105.11, linearGain: 11.3137 }],
					effects: ["chorus", "echo", "reverb"],
					panDelay: 0,
					chorus: 100,
					echoSustain: 57,
					echoDelayBeats: 0.5,
					reverb: 52,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "retro",
					unison: "none",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			// { name: "", generalMidi: false, isNoise: true, tags:[""], settings: {} },
			// { name: "", generalMidi: false, isNoise: true, tags:[""], settings: {} },
			// { name: "", generalMidi: false, isNoise: true, tags:[""], settings: {} },
		]),
	},
	{
		name: "Community Novelty Drum Presets",
		presets: toNameMap([
			// -------------JukeBox 0.2.0 presets--------------
			{
				name: "distorted chip drums - snowirei",
				generalMidi: false,
				isNoise: true,
				tags: ["noise", "snowirei", "novelty"],
				settings: {
					type: "noise",
					eqFilter: [{ type: "low-pass", cutoffHz: 1414.21, linearGain: 5.6569 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 1414.21, linearGain: 5.6569 }],
					eqSubFilters1: [],
					effects: ["vibrato", "distortion", "bitcrusher", "chorus", "echo"],
					vibrato: "none",
					vibratoDepth: 0,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					distortion: 71,
					aliases: false,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 14,
					panDelay: 0,
					chorus: 43,
					echoSustain: 57,
					echoDelayBeats: 0.083,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "hollow",
					unison: "fourths",
					envelopes: [],
				},
			},
			{
				name: "make your drums die - Jacobar475",
				generalMidi: false,
				isNoise: true,
				tags: ["noise", "jacobar475", "novelty"],
				settings: {
					type: "noise",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 1414.21, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 4000, linearGain: 8 },
						{ type: "low-pass", cutoffHz: 8000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 4 },
						{ type: "peak", cutoffHz: 210.22, linearGain: 4 },
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 11.3137 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 1414.21, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 4000, linearGain: 8 },
						{ type: "low-pass", cutoffHz: 8000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 4 },
						{ type: "peak", cutoffHz: 210.22, linearGain: 4 },
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 11.3137 },
					],
					effects: ["granular"],
					granular: 10,
					grainSize: 49,
					grainAmounts: 10,
					grainRange: 40,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "metallic",
					unison: "custom",
					unisonVoices: 9,
					unisonSpread: 0.056,
					unisonOffset: -6,
					unisonExpression: 0.366,
					unisonSign: 0.7,
					envelopes: [],
				},
			},
			// -------------JukeBox 0.2.3 presets--------------
			{
				name: "clap on drugs - deathmodereal",
				generalMidi: false,
				isNoise: true,
				tags: ["spectrum", "novelty"],
				settings: {
					type: "spectrum",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["detune", "vibrato", "reverb"],
					detuneCents: 200,
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					panDelay: 0,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					spectrum: [
						43, 43, 43, 71, 29, 29, 43, 43, 43, 29, 43, 43, 43, 29, 29, 43, 43, 29, 29,
						29, 57, 14, 57, 43, 43, 57, 43, 43, 57, 57,
					],
					unison: "custom",
					unisonVoices: 2,
					unisonSpread: 2,
					unisonOffset: 1,
					unisonExpression: 2,
					unisonSign: 2,
					envelopes: [{ target: "noteVolume", envelope: "punch" }],
				},
			},
			{
				name: "Bitcrushed Drumset - RBLX_INST",
				generalMidi: false,
				isNoise: true,
				tags: ["drumset", "rblx_inst", "novelty"],
				settings: {
					type: "drumset",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.0884 },
						{
							type: "low-pass",
							cutoffHz: 16000,
							linearGain: 0.3536,
						},
						{ type: "peak", cutoffHz: 500, linearGain: 0.25 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.0884 },
						{
							type: "low-pass",
							cutoffHz: 16000,
							linearGain: 0.3536,
						},
						{ type: "peak", cutoffHz: 500, linearGain: 0.25 },
					],
					eqSubFilters1: [],
					effects: [
						"transition type",
						"note filter",
						"distortion",
						"bitcrusher",
						"reverb",
						"ring mod",
					],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 707.11, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.125,
						},
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1.4142 },
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 707.11, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.125,
						},
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1.4142 },
					],
					ringMod: 43,
					ringModHz: 19,
					ringModWaveformIndex: 8,
					ringModPulseWidth: 10,
					ringModHzOffset: 50,
					distortion: 57,
					aliases: false,
					bitcrusherOctave: 3,
					bitcrusherQuantization: 43,
					reverb: 0,
					drums: [
						{
							filterEnvelope: "linear-2",
							spectrum: [
								100, 100, 43, 29, 0, 0, 14, 29, 14, 14, 14, 14, 14, 14, 14, 14, 14,
								14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14,
							],
						},
						{
							filterEnvelope: "linear-1",
							spectrum: [
								100, 100, 14, 14, 14, 14, 14, 14, 0, 0, 0, 0, 0, 14, 43, 29, 29, 29,
								0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 43, 43,
							],
						},
						{
							filterEnvelope: "blip 2",
							spectrum: [
								100, 71, 14, 14, 14, 29, 43, 29, 29, 29, 29, 29, 0, 0, 0, 0, 0, 0,
								0, 0, 0, 0, 0, 0, 0, 14, 14, 0, 0, 14,
							],
						},
						{
							filterEnvelope: "blip 1",
							spectrum: [
								100, 86, 100, 100, 86, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43,
								43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43,
							],
						},
						{
							filterEnvelope: "linear-1",
							spectrum: [
								100, 100, 0, 0, 0, 0, 0, 0, 43, 43, 29, 29, 29, 29, 29, 29, 29, 100,
								100, 100, 100, 100, 100, 100, 71, 71, 71, 71, 71, 71,
							],
						},
						{
							filterEnvelope: "linear-1",
							spectrum: [
								100, 100, 100, 100, 100, 100, 100, 86, 86, 29, 29, 29, 29, 29, 43,
								29, 29, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 43, 43,
							],
						},
						{
							filterEnvelope: "blip 2",
							spectrum: [
								71, 71, 71, 71, 71, 29, 14, 14, 0, 0, 0, 0, 0, 0, 0, 0, 0, 57, 57,
								43, 43, 43, 43, 43, 86, 86, 29, 43, 57, 57,
							],
						},
						{
							filterEnvelope: "blip 1",
							spectrum: [
								57, 43, 43, 43, 43, 43, 0, 0, 0, 0, 0, 0, 0, 0, 0, 14, 29, 29, 29,
								29, 29, 100, 43, 29, 43, 43, 29, 29, 29, 29,
							],
						},
						{
							filterEnvelope: "blip 3",
							spectrum: [
								14, 86, 86, 86, 86, 86, 86, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 43,
								71, 43, 29, 14, 14, 57, 71, 29, 29, 43,
							],
						},
						{
							filterEnvelope: "blip 2",
							spectrum: [
								57, 43, 0, 0, 0, 0, 0, 0, 14, 14, 43, 43, 71, 57, 43, 14, 14, 14,
								14, 14, 14, 0, 0, 0, 0, 14, 29, 43, 29, 43,
							],
						},
						{
							filterEnvelope: "flare -1",
							spectrum: [
								0, 29, 14, 14, 14, 14, 0, 0, 0, 0, 0, 0, 0, 0, 0, 100, 100, 100,
								100, 100, 100, 100, 100, 100, 100, 100, 86, 57, 29, 0,
							],
						},
						{
							filterEnvelope: "fall 2",
							spectrum: [
								14, 14, 14, 14, 29, 14, 14, 29, 14, 43, 14, 43, 57, 86, 57, 57, 100,
								57, 43, 43, 57, 100, 57, 71, 71, 71, 71, 71, 71, 0,
							],
						},
					],
					unison: "double octave",
					envelopes: [
						{
							target: "ringModulationHz",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Beatboxing Bot - SuP3r",
				generalMidi: false,
				isNoise: true,
				tags: ["drumset", "sup3r", "novelty"],
				settings: {
					type: "drumset",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["note filter", "distortion", "bitcrusher"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.7071 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.7071 }],
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 2,
					bitcrusherQuantization: 29,
					panDelay: 0,
					drums: [
						{
							filterEnvelope: "swell 2",
							spectrum: [
								0, 14, 0, 43, 29, 0, 29, 0, 0, 0, 100, 0, 0, 71, 71, 71, 0, 71, 14,
								0, 57, 0, 43, 0, 14, 57, 0, 0, 71, 0,
							],
						},
						{
							filterEnvelope: "tremolo3",
							spectrum: [
								71, 29, 86, 0, 29, 0, 86, 14, 100, 71, 57, 57, 0, 14, 14, 57, 29,
								29, 0, 71, 0, 29, 29, 43, 43, 29, 14, 71, 0, 71,
							],
						},
						{
							filterEnvelope: "decay -1",
							spectrum: [
								0, 71, 14, 100, 29, 0, 14, 29, 29, 100, 0, 57, 0, 14, 0, 14, 14, 43,
								14, 0, 29, 86, 43, 57, 43, 0, 0, 0, 14, 86,
							],
						},
						{
							filterEnvelope: "none",
							spectrum: [
								0, 14, 100, 86, 86, 0, 29, 0, 0, 29, 100, 71, 14, 0, 14, 100, 0,
								100, 0, 14, 86, 0, 0, 71, 71, 29, 14, 14, 14, 100,
							],
						},
						{
							filterEnvelope: "flare -1",
							spectrum: [
								43, 0, 57, 57, 29, 0, 0, 71, 0, 100, 0, 57, 86, 100, 43, 100, 29, 0,
								0, 0, 86, 0, 0, 14, 86, 0, 43, 0, 71, 86,
							],
						},
						{
							filterEnvelope: "twang 2",
							spectrum: [
								14, 0, 14, 29, 0, 14, 57, 0, 14, 0, 14, 0, 57, 0, 100, 29, 14, 29,
								0, 14, 0, 0, 57, 14, 14, 0, 71, 43, 0, 14,
							],
						},
						{
							filterEnvelope: "none",
							spectrum: [
								57, 57, 0, 86, 14, 43, 71, 14, 14, 43, 0, 14, 0, 57, 29, 29, 0, 29,
								14, 57, 29, 0, 43, 71, 29, 29, 100, 14, 71, 43,
							],
						},
						{
							filterEnvelope: "tripolo3",
							spectrum: [
								43, 43, 14, 71, 14, 100, 14, 0, 29, 14, 57, 0, 57, 43, 14, 0, 0, 0,
								0, 43, 14, 29, 0, 100, 43, 14, 86, 71, 29, 0,
							],
						},
						{
							filterEnvelope: "blip 1",
							spectrum: [
								57, 43, 0, 14, 57, 14, 0, 29, 29, 0, 29, 0, 100, 43, 43, 0, 0, 29,
								43, 29, 0, 71, 14, 0, 86, 0, 43, 57, 57, 29,
							],
						},
						{
							filterEnvelope: "blip 2",
							spectrum: [
								0, 14, 0, 57, 43, 0, 100, 57, 29, 71, 0, 43, 14, 29, 0, 100, 14, 43,
								0, 86, 100, 0, 0, 57, 29, 0, 57, 14, 14, 14,
							],
						},
						{
							filterEnvelope: "linear-2",
							spectrum: [
								43, 29, 14, 71, 71, 71, 43, 43, 57, 0, 29, 71, 71, 0, 43, 0, 14, 0,
								100, 43, 86, 0, 43, 57, 100, 43, 43, 0, 14, 0,
							],
						},
						{
							filterEnvelope: "flutter 2",
							spectrum: [
								0, 14, 29, 71, 14, 0, 71, 14, 86, 86, 43, 100, 14, 57, 71, 14, 0, 0,
								86, 0, 57, 57, 57, 43, 0, 0, 0, 29, 0, 14,
							],
						},
					],
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "tremolo6" }],
				},
			},
			{
				name: "Hand Clap - StapyThePinoy",
				generalMidi: false,
				isNoise: true,
				tags: ["drumset", "novelty"],
				settings: {
					type: "drumset",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["reverb"],
					panDelay: 0,
					reverb: 0,
					drums: [
						{
							filterEnvelope: "decay 1",
							spectrum: [
								0, 0, 14, 14, 14, 14, 29, 29, 29, 43, 43, 43, 57, 57, 57, 71, 71,
								71, 71, 71, 71, 71, 71, 57, 57, 57, 57, 43, 43, 43,
							],
						},
						{
							filterEnvelope: "decay 1",
							spectrum: [
								0, 0, 14, 14, 14, 14, 29, 29, 29, 43, 43, 43, 57, 57, 57, 71, 71,
								71, 71, 71, 71, 71, 71, 57, 57, 57, 57, 43, 43, 43,
							],
						},
						{
							filterEnvelope: "decay 1",
							spectrum: [
								0, 0, 14, 14, 14, 14, 29, 29, 29, 43, 43, 43, 57, 57, 57, 71, 71,
								71, 71, 71, 71, 71, 71, 57, 57, 57, 57, 43, 43, 43,
							],
						},
						{
							filterEnvelope: "decay 1",
							spectrum: [
								0, 0, 14, 14, 14, 14, 29, 29, 29, 43, 43, 43, 57, 57, 57, 71, 71,
								71, 71, 71, 71, 71, 71, 57, 57, 57, 57, 43, 43, 43,
							],
						},
						{
							filterEnvelope: "decay 1",
							spectrum: [
								0, 0, 14, 14, 14, 14, 29, 29, 29, 43, 43, 43, 57, 57, 57, 71, 71,
								71, 71, 71, 71, 71, 71, 57, 57, 57, 57, 43, 43, 43,
							],
						},
						{
							filterEnvelope: "decay 1",
							spectrum: [
								0, 0, 14, 14, 14, 14, 29, 29, 29, 43, 43, 43, 57, 57, 57, 71, 71,
								71, 71, 71, 71, 71, 71, 57, 57, 57, 57, 43, 43, 43,
							],
						},
						{
							filterEnvelope: "decay 1",
							spectrum: [
								0, 0, 14, 14, 14, 14, 29, 29, 29, 43, 43, 43, 57, 57, 57, 71, 71,
								71, 71, 71, 71, 71, 71, 57, 57, 57, 57, 43, 43, 43,
							],
						},
						{
							filterEnvelope: "decay 1",
							spectrum: [
								0, 0, 14, 14, 14, 14, 29, 29, 29, 43, 43, 43, 57, 57, 57, 71, 71,
								71, 71, 71, 71, 71, 71, 57, 57, 57, 57, 43, 43, 43,
							],
						},
						{
							filterEnvelope: "decay 1",
							spectrum: [
								0, 0, 14, 14, 14, 14, 29, 29, 29, 43, 43, 43, 57, 57, 57, 71, 71,
								71, 71, 71, 71, 71, 71, 57, 57, 57, 57, 43, 43, 43,
							],
						},
						{
							filterEnvelope: "decay 1",
							spectrum: [
								0, 0, 14, 14, 14, 14, 29, 29, 29, 43, 43, 43, 57, 57, 57, 71, 71,
								71, 71, 71, 71, 71, 71, 57, 57, 57, 57, 43, 43, 43,
							],
						},
						{
							filterEnvelope: "decay 1",
							spectrum: [
								0, 0, 14, 14, 14, 14, 29, 29, 29, 43, 43, 43, 57, 57, 57, 71, 71,
								71, 71, 71, 71, 71, 71, 57, 57, 57, 57, 43, 43, 43,
							],
						},
						{
							filterEnvelope: "decay 1",
							spectrum: [
								0, 0, 14, 14, 14, 14, 29, 29, 29, 43, 43, 43, 57, 57, 57, 71, 71,
								71, 71, 71, 71, 71, 71, 57, 57, 57, 57, 43, 43, 43,
							],
						},
					],
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "Wonky Spectrum - Jayden256",
				generalMidi: false,
				isNoise: true,
				tags: ["spectrum", "jayden256", "novelty"],
				settings: {
					type: "spectrum",
					eqFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.1768 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.1768 }],
					eqSubFilters1: [],
					effects: ["pitch shift", "detune", "bitcrusher", "chorus"],
					pitchShiftSemitones: 0,
					detuneCents: -200,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 43,
					panDelay: 0,
					chorus: 100,
					fadeInSeconds: 0.1575,
					fadeOutTicks: 96,
					spectrum: [
						100, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14,
						14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14,
					],
					unison: "bass",
					envelopes: [],
				},
			},
			{
				name: "Ambience - Jayden256",
				generalMidi: false,
				isNoise: true,
				tags: ["spectrum", "jayden256", "novelty"],
				settings: {
					type: "spectrum",
					eqFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.1768 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.1768 }],
					effects: ["note filter", "bitcrusher", "chorus", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					bitcrusherOctave: 5,
					bitcrusherQuantization: 14,
					panDelay: 10,
					chorus: 100,
					reverb: 48,
					fadeInSeconds: 0.0575,
					fadeOutTicks: 96,
					spectrum: [
						0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
						0, 0, 0, 0, 43,
					],
					unison: "deep shift",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 2.25,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Alien Sound - Jayden256",
				generalMidi: false,
				isNoise: true,
				tags: ["spectrum", "jayden256", "novelty"],
				settings: {
					type: "spectrum",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chord type", "note filter", "reverb"],
					chord: "arpeggio",
					fastTwoNoteArp: true,
					arpeggioSpeed: 28,
					monoChordTone: 1,
					noteFilterType: true,
					noteSimpleCut: 6,
					noteSimplePeak: 1,
					noteFilter: [{ type: "low-pass", cutoffHz: 2500, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 2500, linearGain: 0.5 }],
					panDelay: 0,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					spectrum: [
						14, 14, 29, 29, 43, 43, 57, 71, 71, 71, 86, 86, 100, 71, 43, 0, 14, 29, 29,
						43, 57, 57, 71, 86, 100, 100, 86, 86, 71, 0,
					],
					unison: "none",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Distortion - Jayden256",
				generalMidi: false,
				isNoise: true,
				tags: ["spectrum", "jayden256", "novelty"],
				settings: {
					type: "spectrum",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["pitch shift", "detune", "distortion", "bitcrusher"],
					pitchShiftSemitones: 0,
					detuneCents: -200,
					distortion: 100,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 100,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					spectrum: [
						100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,
						100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,
					],
					unison: "block",
					envelopes: [],
				},
			},
			{
				name: "Clakin - Jayden256",
				generalMidi: false,
				isNoise: true,
				tags: ["noise", "jayden256", "novelty"],
				settings: {
					type: "noise",
					eqFilter: [{ type: "peak", cutoffHz: 250, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "peak", cutoffHz: 250, linearGain: 0.7071 }],
					eqSubFilters1: [],
					effects: ["bitcrusher", "chorus"],
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 14,
					panDelay: 0,
					chorus: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					wave: "clang",
					unison: "extraterrestrial",
					envelopes: [],
				},
			},
			// -------------JukeBox 0.2.4 presets--------------
			{
				name: "Spectral Noise - Ashiiware",
				generalMidi: false,
				isNoise: true,
				tags: ["noise", "ashiiware", "novelty"],
				settings: {
					type: "noise",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["note filter", "bitcrusher", "echo"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 9513.66, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 5656.85, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 4 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 4 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 148.65, linearGain: 4 },
						{ type: "peak", cutoffHz: 88.39, linearGain: 0.1768 },
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 9513.66, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 5656.85, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 4 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 4 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 148.65, linearGain: 4 },
						{ type: "peak", cutoffHz: 88.39, linearGain: 0.1768 },
					],
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 14,
					panDelay: 0,
					echoSustain: 86,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					wave: "1-bit white",
					unison: "none",
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.07,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
							waveform: 0,
							steps: 2,
						},
						{
							target: "noteFilterFreq",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.06,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
							waveform: 0,
							steps: 2,
						},
						{
							target: "noteFilterFreq",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.05,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
							waveform: 0,
							steps: 2,
						},
						{
							target: "noteFilterFreq",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.04,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
							waveform: 0,
							steps: 2,
						},
						{
							target: "noteFilterFreq",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.09,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 4,
							waveform: 0,
							steps: 2,
						},
						{
							target: "noteFilterFreq",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.08,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
							waveform: 0,
							steps: 2,
						},
						{
							target: "noteFilterFreq",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 6,
							waveform: 0,
							steps: 2,
						},
						{
							target: "noteFilterFreq",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.03,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 7,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Alien Sound 2 - Jayden256",
				generalMidi: false,
				isNoise: true,
				tags: ["noise", "jayden256", "novelty"],
				settings: {
					type: "noise",
					eqFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.7071 }],
					effects: ["note filter", "distortion", "bitcrusher", "chorus"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 1000, linearGain: 2 },
						{
							type: "low-pass",
							cutoffHz: 4756.83,
							linearGain: 0.0884,
						},
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 1000, linearGain: 2 },
						{
							type: "low-pass",
							cutoffHz: 4756.83,
							linearGain: 0.0884,
						},
					],
					distortion: 43,
					aliases: false,
					bitcrusherOctave: 4,
					bitcrusherQuantization: 14,
					panDelay: 0,
					chorus: 43,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					wave: "crackling",
					unison: "block",
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 5.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
							waveform: 0,
							steps: 2,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			// -------------JukeBox 0.3.0 presets--------------
			{
				name: "Pipe Clang - Formskooooo",
				generalMidi: false,
				isNoise: true,
				tags: ["noise", "formskooooo", "novelty"],
				settings: {
					type: "noise",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["note filter"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 1 }],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "cutter",
					unison: "hum",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "wibble",
							inverse: false,
							perEnvelopeSpeed: 9.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Orch Mettalurgy - Formskooooo",
				generalMidi: false,
				isNoise: true,
				tags: ["noise", "formskooooo", "novelty"],
				settings: {
					type: "noise",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"pitch shift",
						"detune",
						"vibrato",
						"note filter",
						"distortion",
						"chorus",
						"reverb",
					],
					pitchShiftSemitones: 0,
					detuneCents: -148,
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "peak", cutoffHz: 2828.43, linearGain: 0.0884 }],
					noteSubFilters0: [{ type: "peak", cutoffHz: 2828.43, linearGain: 0.0884 }],
					distortion: 29,
					aliases: false,
					panDelay: 0,
					chorus: 100,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					wave: "deep",
					unison: "honky tonk",
					envelopes: [],
				},
			},
			{
				name: "Waver - Jacobar475",
				generalMidi: false,
				isNoise: true,
				tags: ["spectrum", "jacobar475", "novelty"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 5656.85,
							linearGain: 11.3137,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 5656.85,
							linearGain: 11.3137,
						},
					],
					eqSubFilters1: [],
					effects: ["chord type", "chorus", "reverb"],
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 24,
					monoChordTone: 1,
					panDelay: 0,
					chorus: 100,
					reverb: 71,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					spectrum: [
						0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 14, 29, 29, 43, 43, 57, 43, 29, 14, 0, 0,
						0, 0, 0, 0, 0, 0, 0, 86,
					],
					unison: "hum",
					envelopes: [],
				},
			},
			{
				name: "Scary guy - Luxian",
				generalMidi: false,
				isNoise: true,
				tags: ["spectrum", "novelty"],
				settings: {
					type: "spectrum",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["note filter", "bitcrusher"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.3536 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.3536 }],
					bitcrusherOctave: 3,
					bitcrusherQuantization: 100,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -12,
					unison: "spinner",
					spectrum: [
						0, 0, 0, 0, 71, 0, 0, 0, 0, 100, 0, 0, 0, 0, 0, 86, 71, 0, 0, 0, 0, 0, 43,
						0, 0, 0, 86, 0, 57, 86,
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "linear 2" },
						{
							target: "unison",
							envelope: "decay 2",
						},
					],
				},
			},
			// { name: "", generalMidi: false, isNoise: true, tags:["", "novelty"], settings: {} },
			// { name: "", generalMidi: false, isNoise: true, tags:["", "novelty"], settings: {} },
			// { name: "", generalMidi: false, isNoise: true, tags:["", "novelty"], settings: {} },
		]),
	},
];
